"use strict";

var _objectWithoutProperties = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _toConsumableArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _Lr, _qr, _uo, _yo;

var _excluded = ["static"],
    _excluded2 = ["unmount"],
    _excluded3 = ["as", "children", "refName"],
    _excluded4 = ["features"],
    _excluded5 = ["defaultOpen"],
    _excluded6 = ["value", "name", "onChange", "disabled", "horizontal", "multiple"],
    _excluded7 = ["disabled", "value"],
    _excluded8 = ["passive"],
    _excluded9 = ["value", "name", "onChange", "disabled"],
    _excluded10 = ["value", "disabled"],
    _excluded11 = ["defaultIndex", "vertical", "manual", "onChange", "selectedIndex"],
    _excluded12 = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"],
    _excluded13 = ["show", "appear", "unmount"],
    _excluded14 = ["scope", "children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["asChild"],
    _excluded18 = ["disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss"],
    _excluded19 = ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "flipAlignment"],
    _excluded20 = ["strategy"],
    _excluded21 = ["mainAxis", "crossAxis", "limiter"],
    _excluded22 = ["children", "width", "height"],
    _excluded23 = ["__scopePopper", "virtualRef"],
    _excluded24 = ["__scopePopper", "side", "sideOffset", "align", "alignOffset", "arrowPadding", "collisionBoundary", "collisionPadding", "sticky", "hideWhenDetached", "avoidCollisions"],
    _excluded25 = ["__scopePopper"],
    _excluded26 = ["container"],
    _excluded27 = ["__scopeTooltip"],
    _excluded28 = ["forceMount", "side"],
    _excluded29 = ["__scopeTooltip", "children", "aria-label", "onEscapeKeyDown", "onPointerDownOutside"],
    _excluded30 = ["__scopeTooltip"];

require("core-js/modules/es.object.from-entries.js");

require("core-js/modules/esnext.global-this.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e7) { throw _e7; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e8) { didErr = true; err = _e8; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperties(exports, _defineProperty({
  __esModule: {
    value: !0
  }
}, Symbol.toStringTag, {
  value: "Module"
}));

var l = require("react"),
    Ue = require("react-dom"),
    fn = function fn(e) {
  return e && typeof e == "object" && "default" in e ? e : {
    default: e
  };
};

function pn(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null, _defineProperty({}, Symbol.toStringTag, {
    value: "Module"
  }));

  if (e) {
    var _loop = function _loop(n) {
      if (n !== "default") {
        var r = Object.getOwnPropertyDescriptor(e, n);
        Object.defineProperty(t, n, r.get ? r : {
          enumerable: !0,
          get: function get() {
            return e[n];
          }
        });
      }
    };

    for (var n in e) {
      _loop(n);
    }
  }

  return t.default = e, Object.freeze(t);
}

var h = fn(l),
    T = pn(l),
    pr = pn(Ue),
    gr = fn(Ue);
var F = typeof window < "u" ? l.useLayoutEffect : l.useEffect;

function q(e) {
  var t = l.useRef(e);
  return F(function () {
    t.current = e;
  }, [e]), t;
}

function gn(e, t) {
  var _l$useState = l.useState(e),
      _l$useState2 = _slicedToArray(_l$useState, 2),
      n = _l$useState2[0],
      r = _l$useState2[1],
      o = q(e);

  return F(function () {
    return r(o.current);
  }, [o, r].concat(_toConsumableArray(t))), n;
}

function se() {
  var e = [],
      t = [],
      n = {
    enqueue: function enqueue(r) {
      t.push(r);
    },
    addEventListener: function addEventListener(r, o, i, a) {
      return r.addEventListener(o, i, a), n.add(function () {
        return r.removeEventListener(o, i, a);
      });
    },
    requestAnimationFrame: function (_requestAnimationFrame) {
      function requestAnimationFrame() {
        return _requestAnimationFrame.apply(this, arguments);
      }

      requestAnimationFrame.toString = function () {
        return _requestAnimationFrame.toString();
      };

      return requestAnimationFrame;
    }(function () {
      var o = requestAnimationFrame.apply(void 0, arguments);
      return n.add(function () {
        return cancelAnimationFrame(o);
      });
    }),
    nextFrame: function nextFrame() {
      for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
        r[_key] = arguments[_key];
      }

      return n.requestAnimationFrame(function () {
        return n.requestAnimationFrame.apply(n, r);
      });
    },
    setTimeout: function (_setTimeout) {
      function setTimeout() {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function () {
      var o = setTimeout.apply(void 0, arguments);
      return n.add(function () {
        return clearTimeout(o);
      });
    }),
    add: function add(r) {
      return e.push(r), function () {
        var o = e.indexOf(r);

        if (o >= 0) {
          var _e$splice = e.splice(o, 1),
              _e$splice2 = _slicedToArray(_e$splice, 1),
              i = _e$splice2[0];

          i();
        }
      };
    },
    dispose: function dispose() {
      var _iterator = _createForOfIteratorHelper(e.splice(0)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var r = _step.value;
          r();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    workQueue: function workQueue() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator2, _step2, r;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iterator2 = _createForOfIteratorHelper(t.splice(0));
                _context.prev = 1;

                _iterator2.s();

              case 3:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 9;
                  break;
                }

                r = _step2.value;
                _context.next = 7;
                return r();

              case 7:
                _context.next = 3;
                break;

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);

                _iterator2.e(_context.t0);

              case 14:
                _context.prev = 14;

                _iterator2.f();

                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11, 14, 17]]);
      }))();
    }
  };
  return n;
}

function ke() {
  var _l$useState3 = l.useState(se),
      _l$useState4 = _slicedToArray(_l$useState3, 1),
      e = _l$useState4[0];

  return l.useEffect(function () {
    return function () {
      return e.dispose();
    };
  }, [e]), e;
}

var A = function A(e) {
  var t = q(e);
  return h.default.useCallback(function () {
    return t.current.apply(t, arguments);
  }, [t]);
},
    nt = {
  serverHandoffComplete: !1
};

function xt() {
  var _l$useState5 = l.useState(nt.serverHandoffComplete),
      _l$useState6 = _slicedToArray(_l$useState5, 2),
      e = _l$useState6[0],
      t = _l$useState6[1];

  return l.useEffect(function () {
    e !== !0 && t(!0);
  }, [e]), l.useEffect(function () {
    nt.serverHandoffComplete === !1 && (nt.serverHandoffComplete = !0);
  }, []), e;
}

var Kt;
var mr = 0;

function Yt() {
  return ++mr;
}

var V = (Kt = h.default.useId) != null ? Kt : function () {
  var e = xt(),
      _h$default$useState = h.default.useState(e ? Yt : null),
      _h$default$useState2 = _slicedToArray(_h$default$useState, 2),
      t = _h$default$useState2[0],
      n = _h$default$useState2[1];

  return F(function () {
    t === null && n(Yt());
  }, [t]), t != null ? "" + t : void 0;
};

function N(e, t) {
  if (e in t) {
    var o = t[e];

    for (var _len2 = arguments.length, n = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      n[_key2 - 2] = arguments[_key2];
    }

    return typeof o == "function" ? o.apply(void 0, n) : o;
  }

  var r = new Error("Tried to handle \"".concat(e, "\" but there is no handler defined. Only defined handlers are: ").concat(Object.keys(t).map(function (o) {
    return "\"".concat(o, "\"");
  }).join(", "), "."));
  throw Error.captureStackTrace && Error.captureStackTrace(r, N), r;
}

function we(e) {
  return typeof window > "u" ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}

var st = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map(function (e) {
  return "".concat(e, ":not([tabindex='-1'])");
}).join(",");

var W = function (e) {
  return e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e;
}(W || {}),
    ct = function (e) {
  return e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e;
}(ct || {}),
    vr = function (e) {
  return e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e;
}(vr || {});

function br() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  return e == null ? [] : Array.from(e.querySelectorAll(st));
}

var yt = function (e) {
  return e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e;
}(yt || {});

function mn(e) {
  var _N;

  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n;
  return e === ((n = we(e)) == null ? void 0 : n.body) ? !1 : N(t, (_N = {}, _defineProperty(_N, 0, function _() {
    return e.matches(st);
  }), _defineProperty(_N, 1, function _() {
    var r = e;

    for (; r !== null;) {
      if (r.matches(st)) return !0;
      r = r.parentElement;
    }

    return !1;
  }), _N));
}

var hr = ["textarea", "input"].join(",");

function xr(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, hr)) != null ? n : !1;
}

function xe(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (n) {
    return n;
  };
  return e.slice().sort(function (n, r) {
    var o = t(n),
        i = t(r);
    if (o === null || i === null) return 0;
    var a = o.compareDocumentPosition(i);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}

function ne(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;

  var r = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument,
      o = Array.isArray(e) ? n ? xe(e) : e : br(e),
      i = r.activeElement,
      a = function () {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  }(),
      s = function () {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, o.indexOf(i)) - 1;
    if (t & 4) return Math.max(0, o.indexOf(i)) + 1;
    if (t & 8) return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  }(),
      c = t & 32 ? {
    preventScroll: !0
  } : {},
      u = 0,
      d = o.length,
      f;

  do {
    if (u >= d || u + d <= 0) return 0;
    var p = s + u;
    if (t & 16) p = (p + d) % d;else {
      if (p < 0) return 3;
      if (p >= d) return 1;
    }
    f = o[p], f == null || f.focus(c), u += a;
  } while (f !== r.activeElement);

  return t & 6 && xr(f) && f.select(), f.hasAttribute("tabindex") || f.setAttribute("tabindex", "0"), 2;
}

function Xt(e, t, n) {
  var r = q(t);
  l.useEffect(function () {
    function o(i) {
      r.current(i);
    }

    return window.addEventListener(e, o, n), function () {
      return window.removeEventListener(e, o, n);
    };
  }, [e, n]);
}

function yr(e, t) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  var r = l.useRef(!1);
  l.useEffect(function () {
    requestAnimationFrame(function () {
      r.current = n;
    });
  }, [n]);

  function o(i, a) {
    if (!r.current || i.defaultPrevented) return;

    var s = function u(d) {
      return typeof d == "function" ? u(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e),
        c = a(i);

    if (c !== null && !!c.ownerDocument.documentElement.contains(c)) {
      var _iterator3 = _createForOfIteratorHelper(s),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var u = _step3.value;
          if (u === null) continue;
          var d = u instanceof HTMLElement ? u : u.current;
          if (d != null && d.contains(c)) return;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return !mn(c, yt.Loose) && c.tabIndex !== -1 && i.preventDefault(), t(i, c);
    }
  }

  Xt("click", function (i) {
    return o(i, function (a) {
      return a.target;
    });
  }, !0), Xt("blur", function (i) {
    return o(i, function () {
      return window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null;
    });
  }, !0);
}

function Qt(e) {
  var t;
  if (e.type) return e.type;
  var n = (t = e.as) != null ? t : "button";
  if (typeof n == "string" && n.toLowerCase() === "button") return "button";
}

function wt(e, t) {
  var _l$useState7 = l.useState(function () {
    return Qt(e);
  }),
      _l$useState8 = _slicedToArray(_l$useState7, 2),
      n = _l$useState8[0],
      r = _l$useState8[1];

  return F(function () {
    r(Qt(e));
  }, [e.type, e.as]), F(function () {
    n || !t.current || t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && r("button");
  }, [n, t]), n;
}

var vn = Symbol();

function wr(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  return Object.assign(e, _defineProperty({}, vn, t));
}

function B() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }

  var t = l.useRef(e);
  l.useEffect(function () {
    t.current = e;
  }, [e]);
  var n = A(function (r) {
    var _iterator4 = _createForOfIteratorHelper(t.current),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var o = _step4.value;
        o != null && (typeof o == "function" ? o(r) : o.current = r);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  });
  return e.every(function (r) {
    return r == null || (r == null ? void 0 : r[vn]);
  }) ? void 0 : n;
}

function $r(_ref) {
  var e = _ref.container,
      t = _ref.accept,
      n = _ref.walk,
      _ref$enabled = _ref.enabled,
      r = _ref$enabled === void 0 ? !0 : _ref$enabled;
  var o = l.useRef(t),
      i = l.useRef(n);
  l.useEffect(function () {
    o.current = t, i.current = n;
  }, [t, n]), F(function () {
    if (!e || !r) return;
    var a = we(e);
    if (!a) return;
    var s = o.current,
        c = i.current,
        u = Object.assign(function (f) {
      return s(f);
    }, {
      acceptNode: s
    }),
        d = a.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, u, !1);

    for (; d.nextNode();) {
      c(d.currentNode);
    }
  }, [e, r, o, i]);
}

function Er(e) {
  throw new Error("Unexpected object: " + e);
}

var G = function (e) {
  return e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e;
}(G || {});

function Pr(e, t) {
  var n = t.resolveItems();
  if (n.length <= 0) return null;

  var r = t.resolveActiveIndex(),
      o = r != null ? r : -1,
      i = function () {
    switch (e.focus) {
      case 0:
        return n.findIndex(function (a) {
          return !t.resolveDisabled(a);
        });

      case 1:
        {
          var a = n.slice().reverse().findIndex(function (s, c, u) {
            return o !== -1 && u.length - c - 1 >= o ? !1 : !t.resolveDisabled(s);
          });
          return a === -1 ? a : n.length - 1 - a;
        }

      case 2:
        return n.findIndex(function (a, s) {
          return s <= o ? !1 : !t.resolveDisabled(a);
        });

      case 3:
        {
          var _a2 = n.slice().reverse().findIndex(function (s) {
            return !t.resolveDisabled(s);
          });

          return _a2 === -1 ? _a2 : n.length - 1 - _a2;
        }

      case 4:
        return n.findIndex(function (a) {
          return t.resolveId(a) === e.id;
        });

      case 5:
        return null;

      default:
        Er(e);
    }
  }();

  return i === -1 ? r : i;
}

var re = function (e) {
  return e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e;
}(re || {}),
    Z = function (e) {
  return e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e;
}(Z || {});

function H(_ref2) {
  var e = _ref2.ourProps,
      t = _ref2.theirProps,
      n = _ref2.slot,
      r = _ref2.defaultTag,
      o = _ref2.features,
      _ref2$visible = _ref2.visible,
      i = _ref2$visible === void 0 ? !0 : _ref2$visible,
      a = _ref2.name;
  var s = bn(t, e);
  if (i) return De(s, n, r, a);
  var c = o != null ? o : 0;

  if (c & 2) {
    var _s$static = s.static,
        u = _s$static === void 0 ? !1 : _s$static,
        d = _objectWithoutProperties(s, _excluded);

    if (u) return De(d, n, r, a);
  }

  if (c & 1) {
    var _N2;

    var _s$unmount = s.unmount,
        _u = _s$unmount === void 0 ? !0 : _s$unmount,
        _d = _objectWithoutProperties(s, _excluded2);

    return N(_u ? 0 : 1, (_N2 = {}, _defineProperty(_N2, 0, function _() {
      return null;
    }), _defineProperty(_N2, 1, function _() {
      return De(_objectSpread(_objectSpread({}, _d), {}, {
        hidden: !0,
        style: {
          display: "none"
        }
      }), n, r, a);
    }), _N2));
  }

  return De(s, n, r, a);
}

function De(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var n = arguments.length > 2 ? arguments[2] : undefined;
  var r = arguments.length > 3 ? arguments[3] : undefined;

  var _rt = rt(e, ["unmount", "static"]),
      _rt$as = _rt.as,
      o = _rt$as === void 0 ? n : _rt$as,
      i = _rt.children,
      _rt$refName = _rt.refName,
      a = _rt$refName === void 0 ? "ref" : _rt$refName,
      s = _objectWithoutProperties(_rt, _excluded3),
      c = e.ref !== void 0 ? _defineProperty({}, a, e.ref) : {},
      u = typeof i == "function" ? i(t) : i;

  s.className && typeof s.className == "function" && (s.className = s.className(t));
  var d = {};

  if (o === l.Fragment && Object.keys(Ie(s)).length > 0) {
    if (!l.isValidElement(u) || Array.isArray(u) && u.length > 1) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(r, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(s).map(function (f) {
      return "  - ".concat(f);
    }).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(function (f) {
      return "  - ".concat(f);
    }).join("\n")].join("\n"));
    return l.cloneElement(u, Object.assign({}, bn(u.props, Ie(rt(s, ["ref"]))), d, c));
  }

  return l.createElement(o, Object.assign({}, rt(s, ["ref"]), o !== l.Fragment && c, o !== l.Fragment && d), u);
}

function bn() {
  for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    e[_key4] = arguments[_key4];
  }

  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  var t = {},
      n = {};

  for (var _i2 = 0, _e2 = e; _i2 < _e2.length; _i2++) {
    var r = _e2[_i2];

    for (var o in r) {
      o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
    }
  }

  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map(function (r) {
    return [r, void 0];
  })));

  var _loop2 = function _loop2(_r2) {
    Object.assign(t, _defineProperty({}, _r2, function (o) {
      var a = n[_r2];

      for (var _len5 = arguments.length, i = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        i[_key5 - 1] = arguments[_key5];
      }

      var _iterator5 = _createForOfIteratorHelper(a),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var s = _step5.value;
          if (o.defaultPrevented) return;
          s.apply(void 0, [o].concat(i));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }));
  };

  for (var _r2 in n) {
    _loop2(_r2);
  }

  return t;
}

function M(e) {
  var t;
  return Object.assign(l.forwardRef(e), {
    displayName: (t = e.displayName) != null ? t : e.name
  });
}

function Ie(e) {
  var t = Object.assign({}, e);

  for (var n in t) {
    t[n] === void 0 && delete t[n];
  }

  return t;
}

function rt(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var n = Object.assign({}, e);

  var _iterator6 = _createForOfIteratorHelper(t),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var r = _step6.value;
      r in n && delete n[r];
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return n;
}

function hn(e) {
  var t = e.parentElement,
      n = null;

  for (; t && !(t instanceof HTMLFieldSetElement);) {
    t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  }

  var r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && Cr(n) ? !1 : r;
}

function Cr(e) {
  if (!e) return !1;
  var t = e.previousElementSibling;

  for (; t !== null;) {
    if (t instanceof HTMLLegendElement) return !1;
    t = t.previousElementSibling;
  }

  return !0;
}

function $t() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  for (var _i3 = 0, _Object$entries = Object.entries(e); _i3 < _Object$entries.length; _i3++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
        r = _Object$entries$_i[0],
        o = _Object$entries$_i[1];

    yn(n, xn(t, r), o);
  }

  return n;
}

function xn(e, t) {
  return e ? e + "[" + t + "]" : t;
}

function yn(e, t, n) {
  if (Array.isArray(n)) {
    var _iterator7 = _createForOfIteratorHelper(n.entries()),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _step7$value = _slicedToArray(_step7.value, 2),
            r = _step7$value[0],
            o = _step7$value[1];

        yn(e, xn(t, r.toString()), o);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  } else n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, "".concat(n)]) : n == null ? e.push([t, ""]) : $t(n, t, e);
}

function Tr(e) {
  var t;
  var n = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");

  if (n) {
    var _iterator8 = _createForOfIteratorHelper(n.elements),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var r = _step8.value;

        if (r.tagName === "INPUT" && r.type === "submit" || r.tagName === "BUTTON" && r.type === "submit" || r.nodeName === "INPUT" && r.type === "image") {
          r.click();
          return;
        }
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }
}

var Or = "div";

var We = function (e) {
  return e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e;
}(We || {});

var Et = M(function (e, t) {
  var _e$features = e.features,
      n = _e$features === void 0 ? 1 : _e$features,
      r = _objectWithoutProperties(e, _excluded4),
      o = {
    ref: t,
    "aria-hidden": (n & 2) === 2 ? !0 : void 0,
    style: _objectSpread({
      position: "absolute",
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      borderWidth: "0"
    }, (n & 4) === 4 && (n & 2) !== 2 && {
      display: "none"
    })
  };

  return H({
    ourProps: o,
    theirProps: r,
    slot: {},
    defaultTag: Or,
    name: "Hidden"
  });
}),
    Pt = l.createContext(null);
Pt.displayName = "OpenClosedContext";

var K = function (e) {
  return e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e;
}(K || {});

function Ve() {
  return l.useContext(Pt);
}

function Ct(_ref4) {
  var e = _ref4.value,
      t = _ref4.children;
  return h.default.createElement(Pt.Provider, {
    value: e
  }, t);
}

var S = function (e) {
  return e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e;
}(S || {});

function wn() {
  var e = l.useRef(!1);
  return F(function () {
    return e.current = !0, function () {
      e.current = !1;
    };
  }, []), e;
}

function Rr(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch(function (t) {
    return setTimeout(function () {
      throw t;
    });
  });
}

var $n = l.createContext(null);

function En() {
  var e = l.useContext($n);

  if (e === null) {
    var t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, En), t;
  }

  return e;
}

function Pn() {
  var _l$useState9 = l.useState([]),
      _l$useState10 = _slicedToArray(_l$useState9, 2),
      e = _l$useState10[0],
      t = _l$useState10[1];

  return [e.length > 0 ? e.join(" ") : void 0, l.useMemo(function () {
    return function (n) {
      var r = A(function (i) {
        return t(function (a) {
          return [].concat(_toConsumableArray(a), [i]);
        }), function () {
          return t(function (a) {
            var s = a.slice(),
                c = s.indexOf(i);
            return c !== -1 && s.splice(c, 1), s;
          });
        };
      }),
          o = l.useMemo(function () {
        return {
          register: r,
          slot: n.slot,
          name: n.name,
          props: n.props
        };
      }, [r, n.slot, n.name, n.props]);
      return h.default.createElement($n.Provider, {
        value: o
      }, n.children);
    };
  }, [t])];
}

var Sr = "p",
    Ar = M(function (e, t) {
  var n = En(),
      r = "headlessui-description-".concat(V()),
      o = B(t);
  F(function () {
    return n.register(r);
  }, [r, n.register]);

  var i = e,
      a = _objectSpread(_objectSpread({
    ref: o
  }, n.props), {}, {
    id: r
  });

  return H({
    ourProps: a,
    theirProps: i,
    slot: n.slot || {},
    defaultTag: Sr,
    name: n.name || "Description"
  });
});

var Dr = function (e) {
  return e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e;
}(Dr || {}),
    Nr = function (e) {
  return e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.LinkPanel = 4] = "LinkPanel", e[e.UnlinkPanel = 5] = "UnlinkPanel", e;
}(Nr || {});

var Lr = (_Lr = {}, _defineProperty(_Lr, 0, function _(e) {
  var _N3;

  return _objectSpread(_objectSpread({}, e), {}, {
    disclosureState: N(e.disclosureState, (_N3 = {}, _defineProperty(_N3, 0, 1), _defineProperty(_N3, 1, 0), _N3))
  });
}), _defineProperty(_Lr, 1, function _(e) {
  return e.disclosureState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    disclosureState: 1
  });
}), _defineProperty(_Lr, 4, function _(e) {
  return e.linkedPanel === !0 ? e : _objectSpread(_objectSpread({}, e), {}, {
    linkedPanel: !0
  });
}), _defineProperty(_Lr, 5, function _(e) {
  return e.linkedPanel === !1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    linkedPanel: !1
  });
}), _defineProperty(_Lr, 2, function _(e, t) {
  return e.buttonId === t.buttonId ? e : _objectSpread(_objectSpread({}, e), {}, {
    buttonId: t.buttonId
  });
}), _defineProperty(_Lr, 3, function _(e, t) {
  return e.panelId === t.panelId ? e : _objectSpread(_objectSpread({}, e), {}, {
    panelId: t.panelId
  });
}), _Lr),
    Tt = l.createContext(null);
Tt.displayName = "DisclosureContext";

function Ot(e) {
  var t = l.useContext(Tt);

  if (t === null) {
    var n = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(n, Ot), n;
  }

  return t;
}

var Rt = l.createContext(null);
Rt.displayName = "DisclosureAPIContext";

function Cn(e) {
  var t = l.useContext(Rt);

  if (t === null) {
    var n = new Error("<".concat(e, " /> is missing a parent <Disclosure /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(n, Cn), n;
  }

  return t;
}

var St = l.createContext(null);
St.displayName = "DisclosurePanelContext";

function kr() {
  return l.useContext(St);
}

function Ir(e, t) {
  return N(t.type, Lr, e, t);
}

var Fr = l.Fragment,
    _r = M(function (e, t) {
  var _N4;

  var _e$defaultOpen = e.defaultOpen,
      n = _e$defaultOpen === void 0 ? !1 : _e$defaultOpen,
      r = _objectWithoutProperties(e, _excluded5),
      o = "headlessui-disclosure-button-".concat(V()),
      i = "headlessui-disclosure-panel-".concat(V()),
      a = l.useRef(null),
      s = B(t, wr(function (x) {
    a.current = x;
  }, e.as === void 0 || e.as === h.default.Fragment)),
      c = l.useRef(null),
      u = l.useRef(null),
      d = l.useReducer(Ir, {
    disclosureState: n ? 0 : 1,
    linkedPanel: !1,
    buttonRef: u,
    panelRef: c,
    buttonId: o,
    panelId: i
  }),
      _d2 = _slicedToArray(d, 2),
      f = _d2[0].disclosureState,
      p = _d2[1];

  l.useEffect(function () {
    return p({
      type: 2,
      buttonId: o
    });
  }, [o, p]), l.useEffect(function () {
    return p({
      type: 3,
      panelId: i
    });
  }, [i, p]);
  var g = A(function (x) {
    p({
      type: 1
    });
    var w = we(a);
    if (!w) return;

    var y = function () {
      return x ? x instanceof HTMLElement ? x : x.current instanceof HTMLElement ? x.current : w.getElementById(o) : w.getElementById(o);
    }();

    y == null || y.focus();
  }),
      v = l.useMemo(function () {
    return {
      close: g
    };
  }, [g]),
      b = l.useMemo(function () {
    return {
      open: f === 0,
      close: g
    };
  }, [f, g]),
      m = {
    ref: s
  };
  return h.default.createElement(Tt.Provider, {
    value: d
  }, h.default.createElement(Rt.Provider, {
    value: v
  }, h.default.createElement(Ct, {
    value: N(f, (_N4 = {}, _defineProperty(_N4, 0, K.Open), _defineProperty(_N4, 1, K.Closed), _N4))
  }, H({
    ourProps: m,
    theirProps: r,
    slot: b,
    defaultTag: Fr,
    name: "Disclosure"
  }))));
}),
    Mr = "button",
    Hr = M(function (e, t) {
  var _Ot = Ot("Disclosure.Button"),
      _Ot2 = _slicedToArray(_Ot, 2),
      n = _Ot2[0],
      r = _Ot2[1],
      o = kr(),
      i = o === null ? !1 : o === n.panelId,
      a = l.useRef(null),
      s = B(a, t, i ? null : n.buttonRef),
      c = A(function (b) {
    var m;

    if (i) {
      if (n.disclosureState === 1) return;

      switch (b.key) {
        case S.Space:
        case S.Enter:
          b.preventDefault(), b.stopPropagation(), r({
            type: 0
          }), (m = n.buttonRef.current) == null || m.focus();
          break;
      }
    } else switch (b.key) {
      case S.Space:
      case S.Enter:
        b.preventDefault(), b.stopPropagation(), r({
          type: 0
        });
        break;
    }
  }),
      u = A(function (b) {
    switch (b.key) {
      case S.Space:
        b.preventDefault();
        break;
    }
  }),
      d = A(function (b) {
    var m;
    hn(b.currentTarget) || e.disabled || (i ? (r({
      type: 0
    }), (m = n.buttonRef.current) == null || m.focus()) : r({
      type: 0
    }));
  }),
      f = l.useMemo(function () {
    return {
      open: n.disclosureState === 0
    };
  }, [n]),
      p = wt(e, a),
      g = e,
      v = i ? {
    ref: s,
    type: p,
    onKeyDown: c,
    onClick: d
  } : {
    ref: s,
    id: n.buttonId,
    type: p,
    "aria-expanded": e.disabled ? void 0 : n.disclosureState === 0,
    "aria-controls": n.linkedPanel ? n.panelId : void 0,
    onKeyDown: c,
    onKeyUp: u,
    onClick: d
  };

  return H({
    ourProps: v,
    theirProps: g,
    slot: f,
    defaultTag: Mr,
    name: "Disclosure.Button"
  });
}),
    Br = "div",
    jr = re.RenderStrategy | re.Static,
    Ur = M(function (e, t) {
  var _Ot3 = Ot("Disclosure.Panel"),
      _Ot4 = _slicedToArray(_Ot3, 2),
      n = _Ot4[0],
      r = _Ot4[1],
      _Cn = Cn("Disclosure.Panel"),
      o = _Cn.close,
      i = B(t, n.panelRef, function () {
    n.linkedPanel || r({
      type: 4
    });
  }),
      a = Ve(),
      s = function () {
    return a !== null ? a === K.Open : n.disclosureState === 0;
  }();

  l.useEffect(function () {
    return function () {
      return r({
        type: 5
      });
    };
  }, [r]), l.useEffect(function () {
    var f;
    n.disclosureState === 1 && ((f = e.unmount) != null ? f : !0) && r({
      type: 5
    });
  }, [n.disclosureState, e.unmount, r]);
  var c = l.useMemo(function () {
    return {
      open: n.disclosureState === 0,
      close: o
    };
  }, [n, o]),
      u = e,
      d = {
    ref: i,
    id: n.panelId
  };
  return h.default.createElement(St.Provider, {
    value: n.panelId
  }, H({
    ourProps: d,
    theirProps: u,
    slot: c,
    defaultTag: Br,
    features: jr,
    visible: s,
    name: "Disclosure.Panel"
  }));
}),
    ot = Object.assign(_r, {
  Button: Hr,
  Panel: Ur
});

var Wr = function (e) {
  return e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e;
}(Wr || {}),
    Vr = function (e) {
  return e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e;
}(Vr || {}),
    zr = function (e) {
  return e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e;
}(zr || {}),
    Gr = function (e) {
  return e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.SetDisabled = 2] = "SetDisabled", e[e.SetOrientation = 3] = "SetOrientation", e[e.GoToOption = 4] = "GoToOption", e[e.Search = 5] = "Search", e[e.ClearSearch = 6] = "ClearSearch", e[e.RegisterOption = 7] = "RegisterOption", e[e.UnregisterOption = 8] = "UnregisterOption", e;
}(Gr || {});

function it(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (n) {
    return n;
  };
  var n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null,
      r = xe(t(e.options.slice()), function (i) {
    return i.dataRef.current.domRef.current;
  }),
      o = n ? r.indexOf(n) : null;
  return o === -1 && (o = null), {
    options: r,
    activeOptionIndex: o
  };
}

var qr = (_qr = {}, _defineProperty(_qr, 1, function _(e) {
  return e.disabled || e.listboxState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
    activeOptionIndex: null,
    listboxState: 1
  });
}), _defineProperty(_qr, 0, function _(e) {
  if (e.disabled || e.listboxState === 0) return e;
  var t = e.activeOptionIndex,
      _e$propsRef$current = e.propsRef.current,
      n = _e$propsRef$current.value,
      r = _e$propsRef$current.mode,
      o = _e$propsRef$current.compare,
      i = e.options.findIndex(function (a) {
    var _N5;

    var s = a.dataRef.current.value;
    return N(r, (_N5 = {}, _defineProperty(_N5, 1, function _() {
      return n.some(function (c) {
        return o(c, s);
      });
    }), _defineProperty(_N5, 0, function _() {
      return o(n, s);
    }), _N5));
  });
  return i !== -1 && (t = i), _objectSpread(_objectSpread({}, e), {}, {
    listboxState: 0,
    activeOptionIndex: t
  });
}), _defineProperty(_qr, 2, function _(e, t) {
  return e.disabled === t.disabled ? e : _objectSpread(_objectSpread({}, e), {}, {
    disabled: t.disabled
  });
}), _defineProperty(_qr, 3, function _(e, t) {
  return e.orientation === t.orientation ? e : _objectSpread(_objectSpread({}, e), {}, {
    orientation: t.orientation
  });
}), _defineProperty(_qr, 4, function _(e, t) {
  var n;
  if (e.disabled || e.listboxState === 1) return e;
  var r = it(e),
      o = Pr(t, {
    resolveItems: function resolveItems() {
      return r.options;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return r.activeOptionIndex;
    },
    resolveId: function resolveId(i) {
      return i.id;
    },
    resolveDisabled: function resolveDisabled(i) {
      return i.dataRef.current.disabled;
    }
  });
  return _objectSpread(_objectSpread(_objectSpread({}, e), r), {}, {
    searchQuery: "",
    activeOptionIndex: o,
    activationTrigger: (n = t.trigger) != null ? n : 1
  });
}), _defineProperty(_qr, 5, function _(e, t) {
  if (e.disabled || e.listboxState === 1) return e;
  var n = e.searchQuery !== "" ? 0 : 1,
      r = e.searchQuery + t.value.toLowerCase(),
      o = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + n).concat(e.options.slice(0, e.activeOptionIndex + n)) : e.options).find(function (a) {
    var s;
    return !a.dataRef.current.disabled && ((s = a.dataRef.current.textValue) == null ? void 0 : s.startsWith(r));
  }),
      i = o ? e.options.indexOf(o) : -1;
  return i === -1 || i === e.activeOptionIndex ? _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: r
  }) : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: r,
    activeOptionIndex: i,
    activationTrigger: 1
  });
}), _defineProperty(_qr, 6, function _(e) {
  return e.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : _objectSpread(_objectSpread({}, e), {}, {
    searchQuery: ""
  });
}), _defineProperty(_qr, 7, function _(e, t) {
  var n = {
    id: t.id,
    dataRef: t.dataRef
  },
      r = it(e, function (o) {
    return [].concat(_toConsumableArray(o), [n]);
  });

  if (e.activeOptionIndex === null) {
    var _N6;

    var _e$propsRef$current2 = e.propsRef.current,
        o = _e$propsRef$current2.value,
        i = _e$propsRef$current2.mode,
        a = _e$propsRef$current2.compare,
        s = t.dataRef.current.value;
    N(i, (_N6 = {}, _defineProperty(_N6, 1, function _() {
      return o.some(function (c) {
        return a(c, s);
      });
    }), _defineProperty(_N6, 0, function _() {
      return a(o, s);
    }), _N6)) && (r.activeOptionIndex = r.options.indexOf(n));
  }

  return _objectSpread(_objectSpread({}, e), r);
}), _defineProperty(_qr, 8, function _(e, t) {
  var n = it(e, function (r) {
    var o = r.findIndex(function (i) {
      return i.id === t.id;
    });
    return o !== -1 && r.splice(o, 1), r;
  });
  return _objectSpread(_objectSpread(_objectSpread({}, e), n), {}, {
    activationTrigger: 1
  });
}), _qr),
    At = l.createContext(null);
At.displayName = "ListboxContext";

function $e(e) {
  var t = l.useContext(At);

  if (t === null) {
    var n = new Error("<".concat(e, " /> is missing a parent <Listbox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(n, $e), n;
  }

  return t;
}

function Kr(e, t) {
  return N(t.type, qr, e, t);
}

var Yr = l.Fragment,
    Xr = M(function (e, t) {
  var _N8;

  var n = e.value,
      r = e.name,
      o = e.onChange,
      _e$disabled = e.disabled,
      i = _e$disabled === void 0 ? !1 : _e$disabled,
      _e$horizontal = e.horizontal,
      a = _e$horizontal === void 0 ? !1 : _e$horizontal,
      _e$multiple = e.multiple,
      s = _e$multiple === void 0 ? !1 : _e$multiple,
      c = _objectWithoutProperties(e, _excluded6);

  var u = a ? "horizontal" : "vertical";

  var d = B(t),
      f = l.useReducer(Kr, {
    listboxState: 1,
    propsRef: {
      current: {
        value: n,
        onChange: o,
        mode: s ? 1 : 0,
        compare: A(function (y, $) {
          return y === $;
        })
      }
    },
    labelRef: l.createRef(),
    buttonRef: l.createRef(),
    optionsRef: l.createRef(),
    disabled: i,
    orientation: u,
    options: [],
    searchQuery: "",
    activeOptionIndex: null,
    activationTrigger: 1
  }),
      _f = _slicedToArray(f, 2),
      _f$ = _f[0],
      p = _f$.listboxState,
      g = _f$.propsRef,
      v = _f$.optionsRef,
      b = _f$.buttonRef,
      m = _f[1];

  g.current.value = n, g.current.mode = s ? 1 : 0, F(function () {
    g.current.onChange = function (y) {
      var _N7;

      return N(g.current.mode, (_N7 = {}, _defineProperty(_N7, 0, function _() {
        return o(y);
      }), _defineProperty(_N7, 1, function _() {
        var $ = g.current.value.slice(),
            C = $.indexOf(y);
        return C === -1 ? $.push(y) : $.splice(C, 1), o($);
      }), _N7));
    };
  }, [o, g]), F(function () {
    return m({
      type: 2,
      disabled: i
    });
  }, [i]), F(function () {
    return m({
      type: 3,
      orientation: u
    });
  }, [u]), yr([b, v], function (y, $) {
    var C;
    m({
      type: 1
    }), mn($, yt.Loose) || (y.preventDefault(), (C = b.current) == null || C.focus());
  }, p === 0);
  var x = l.useMemo(function () {
    return {
      open: p === 0,
      disabled: i
    };
  }, [p, i]),
      w = {
    ref: d
  };
  return h.default.createElement(At.Provider, {
    value: f
  }, h.default.createElement(Ct, {
    value: N(p, (_N8 = {}, _defineProperty(_N8, 0, K.Open), _defineProperty(_N8, 1, K.Closed), _N8))
  }, r != null && n != null && $t(_defineProperty({}, r, n)).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        y = _ref6[0],
        $ = _ref6[1];

    return h.default.createElement(Et, _objectSpread({
      features: We.Hidden
    }, Ie({
      key: y,
      as: "input",
      type: "hidden",
      hidden: !0,
      readOnly: !0,
      name: y,
      value: $
    })));
  }), H({
    ourProps: w,
    theirProps: c,
    slot: x,
    defaultTag: Yr,
    name: "Listbox"
  })));
}),
    Qr = "button",
    Zr = M(function (e, t) {
  var n;

  var _$e = $e("Listbox.Button"),
      _$e2 = _slicedToArray(_$e, 2),
      r = _$e2[0],
      o = _$e2[1],
      i = B(r.buttonRef, t),
      a = "headlessui-listbox-button-".concat(V()),
      s = ke(),
      c = A(function (b) {
    switch (b.key) {
      case S.Space:
      case S.Enter:
      case S.ArrowDown:
        b.preventDefault(), o({
          type: 0
        }), s.nextFrame(function () {
          r.propsRef.current.value || o({
            type: 4,
            focus: G.First
          });
        });
        break;

      case S.ArrowUp:
        b.preventDefault(), o({
          type: 0
        }), s.nextFrame(function () {
          r.propsRef.current.value || o({
            type: 4,
            focus: G.Last
          });
        });
        break;
    }
  }),
      u = A(function (b) {
    switch (b.key) {
      case S.Space:
        b.preventDefault();
        break;
    }
  }),
      d = A(function (b) {
    if (hn(b.currentTarget)) return b.preventDefault();
    r.listboxState === 0 ? (o({
      type: 1
    }), s.nextFrame(function () {
      var m;
      return (m = r.buttonRef.current) == null ? void 0 : m.focus({
        preventScroll: !0
      });
    })) : (b.preventDefault(), o({
      type: 0
    }));
  }),
      f = gn(function () {
    if (r.labelRef.current) return [r.labelRef.current.id, a].join(" ");
  }, [r.labelRef.current, a]),
      p = l.useMemo(function () {
    return {
      open: r.listboxState === 0,
      disabled: r.disabled
    };
  }, [r]),
      g = e,
      v = {
    ref: i,
    id: a,
    type: wt(e, r.buttonRef),
    "aria-haspopup": !0,
    "aria-controls": (n = r.optionsRef.current) == null ? void 0 : n.id,
    "aria-expanded": r.disabled ? void 0 : r.listboxState === 0,
    "aria-labelledby": f,
    disabled: r.disabled,
    onKeyDown: c,
    onKeyUp: u,
    onClick: d
  };

  return H({
    ourProps: v,
    theirProps: g,
    slot: p,
    defaultTag: Qr,
    name: "Listbox.Button"
  });
}),
    Jr = "label",
    eo = M(function (e, t) {
  var _$e3 = $e("Listbox.Label"),
      _$e4 = _slicedToArray(_$e3, 1),
      n = _$e4[0],
      r = "headlessui-listbox-label-".concat(V()),
      o = B(n.labelRef, t),
      i = A(function () {
    var s;
    return (s = n.buttonRef.current) == null ? void 0 : s.focus({
      preventScroll: !0
    });
  }),
      a = l.useMemo(function () {
    return {
      open: n.listboxState === 0,
      disabled: n.disabled
    };
  }, [n]);

  return H({
    ourProps: {
      ref: o,
      id: r,
      onClick: i
    },
    theirProps: e,
    slot: a,
    defaultTag: Jr,
    name: "Listbox.Label"
  });
}),
    to = "ul",
    no = re.RenderStrategy | re.Static,
    ro = M(function (e, t) {
  var n;

  var _$e5 = $e("Listbox.Options"),
      _$e6 = _slicedToArray(_$e5, 2),
      r = _$e6[0],
      o = _$e6[1],
      i = B(r.optionsRef, t),
      a = "headlessui-listbox-options-".concat(V()),
      s = ke(),
      c = ke(),
      u = Ve(),
      d = function () {
    return u !== null ? u === K.Open : r.listboxState === 0;
  }();

  l.useEffect(function () {
    var m;
    var x = r.optionsRef.current;
    !x || r.listboxState === 0 && x !== ((m = we(x)) == null ? void 0 : m.activeElement) && x.focus({
      preventScroll: !0
    });
  }, [r.listboxState, r.optionsRef]);
  var f = A(function (m) {
    switch (c.dispose(), m.key) {
      case S.Space:
        if (r.searchQuery !== "") return m.preventDefault(), m.stopPropagation(), o({
          type: 5,
          value: m.key
        });

      case S.Enter:
        if (m.preventDefault(), m.stopPropagation(), r.activeOptionIndex !== null) {
          var x = r.options[r.activeOptionIndex].dataRef;
          r.propsRef.current.onChange(x.current.value);
        }

        r.propsRef.current.mode === 0 && (o({
          type: 1
        }), se().nextFrame(function () {
          var x;
          return (x = r.buttonRef.current) == null ? void 0 : x.focus({
            preventScroll: !0
          });
        }));
        break;

      case N(r.orientation, {
        vertical: S.ArrowDown,
        horizontal: S.ArrowRight
      }):
        return m.preventDefault(), m.stopPropagation(), o({
          type: 4,
          focus: G.Next
        });

      case N(r.orientation, {
        vertical: S.ArrowUp,
        horizontal: S.ArrowLeft
      }):
        return m.preventDefault(), m.stopPropagation(), o({
          type: 4,
          focus: G.Previous
        });

      case S.Home:
      case S.PageUp:
        return m.preventDefault(), m.stopPropagation(), o({
          type: 4,
          focus: G.First
        });

      case S.End:
      case S.PageDown:
        return m.preventDefault(), m.stopPropagation(), o({
          type: 4,
          focus: G.Last
        });

      case S.Escape:
        return m.preventDefault(), m.stopPropagation(), o({
          type: 1
        }), s.nextFrame(function () {
          var x;
          return (x = r.buttonRef.current) == null ? void 0 : x.focus({
            preventScroll: !0
          });
        });

      case S.Tab:
        m.preventDefault(), m.stopPropagation();
        break;

      default:
        m.key.length === 1 && (o({
          type: 5,
          value: m.key
        }), c.setTimeout(function () {
          return o({
            type: 6
          });
        }, 350));
        break;
    }
  }),
      p = gn(function () {
    var m, x, w;
    return (w = (m = r.labelRef.current) == null ? void 0 : m.id) != null ? w : (x = r.buttonRef.current) == null ? void 0 : x.id;
  }, [r.labelRef.current, r.buttonRef.current]),
      g = l.useMemo(function () {
    return {
      open: r.listboxState === 0
    };
  }, [r]),
      v = e,
      b = {
    "aria-activedescendant": r.activeOptionIndex === null || (n = r.options[r.activeOptionIndex]) == null ? void 0 : n.id,
    "aria-multiselectable": r.propsRef.current.mode === 1 ? !0 : void 0,
    "aria-labelledby": p,
    "aria-orientation": r.orientation,
    id: a,
    onKeyDown: f,
    role: "listbox",
    tabIndex: 0,
    ref: i
  };
  return H({
    ourProps: b,
    theirProps: v,
    slot: g,
    defaultTag: to,
    features: no,
    visible: d,
    name: "Listbox.Options"
  });
}),
    oo = "li",
    io = M(function (e, t) {
  var _N9;

  var _e$disabled2 = e.disabled,
      n = _e$disabled2 === void 0 ? !1 : _e$disabled2,
      r = e.value,
      o = _objectWithoutProperties(e, _excluded7),
      _$e7 = $e("Listbox.Option"),
      _$e8 = _slicedToArray(_$e7, 2),
      i = _$e8[0],
      a = _$e8[1],
      s = "headlessui-listbox-option-".concat(V()),
      c = i.activeOptionIndex !== null ? i.options[i.activeOptionIndex].id === s : !1,
      _i$propsRef$current = i.propsRef.current,
      u = _i$propsRef$current.value,
      d = _i$propsRef$current.compare,
      f = N(i.propsRef.current.mode, (_N9 = {}, _defineProperty(_N9, 1, function _() {
    return u.some(function (C) {
      return d(C, r);
    });
  }), _defineProperty(_N9, 0, function _() {
    return d(u, r);
  }), _N9)),
      p = l.useRef(null),
      g = B(t, p);

  F(function () {
    if (i.listboxState !== 0 || !c || i.activationTrigger === 0) return;
    var C = se();
    return C.requestAnimationFrame(function () {
      var E, R;
      (R = (E = p.current) == null ? void 0 : E.scrollIntoView) == null || R.call(E, {
        block: "nearest"
      });
    }), C.dispose;
  }, [p, c, i.listboxState, i.activationTrigger, i.activeOptionIndex]);
  var v = l.useRef({
    disabled: n,
    value: r,
    domRef: p
  });
  F(function () {
    v.current.disabled = n;
  }, [v, n]), F(function () {
    v.current.value = r;
  }, [v, r]), F(function () {
    var C, E;
    v.current.textValue = (E = (C = p.current) == null ? void 0 : C.textContent) == null ? void 0 : E.toLowerCase();
  }, [v, p]);
  var b = A(function () {
    return i.propsRef.current.onChange(r);
  });
  F(function () {
    return a({
      type: 7,
      id: s,
      dataRef: v
    }), function () {
      return a({
        type: 8,
        id: s
      });
    };
  }, [v, s]);
  var m = A(function (C) {
    if (n) return C.preventDefault();
    b(), i.propsRef.current.mode === 0 && (a({
      type: 1
    }), se().nextFrame(function () {
      var E;
      return (E = i.buttonRef.current) == null ? void 0 : E.focus({
        preventScroll: !0
      });
    }));
  }),
      x = A(function () {
    if (n) return a({
      type: 4,
      focus: G.Nothing
    });
    a({
      type: 4,
      focus: G.Specific,
      id: s
    });
  }),
      w = A(function () {
    n || c || a({
      type: 4,
      focus: G.Specific,
      id: s,
      trigger: 0
    });
  }),
      y = A(function () {
    n || !c || a({
      type: 4,
      focus: G.Nothing
    });
  }),
      $ = l.useMemo(function () {
    return {
      active: c,
      selected: f,
      disabled: n
    };
  }, [c, f, n]);
  return H({
    ourProps: {
      id: s,
      ref: g,
      role: "option",
      tabIndex: n === !0 ? void 0 : -1,
      "aria-disabled": n === !0 ? !0 : void 0,
      "aria-selected": f === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: m,
      onFocus: x,
      onPointerMove: w,
      onMouseMove: w,
      onPointerLeave: y,
      onMouseLeave: y
    },
    theirProps: o,
    slot: $,
    defaultTag: oo,
    name: "Listbox.Option"
  });
}),
    ve = Object.assign(Xr, {
  Button: Zr,
  Label: eo,
  Options: ro,
  Option: io
});

function ao() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _l$useState11 = l.useState(e),
      _l$useState12 = _slicedToArray(_l$useState11, 2),
      t = _l$useState12[0],
      n = _l$useState12[1],
      r = l.useCallback(function (s) {
    return n(function (c) {
      return c | s;
    });
  }, [t]),
      o = l.useCallback(function (s) {
    return Boolean(t & s);
  }, [t]),
      i = l.useCallback(function (s) {
    return n(function (c) {
      return c & ~s;
    });
  }, [n]),
      a = l.useCallback(function (s) {
    return n(function (c) {
      return c ^ s;
    });
  }, [n]);

  return {
    addFlag: r,
    hasFlag: o,
    removeFlag: i,
    toggleFlag: a
  };
}

var Tn = l.createContext(null);

function On() {
  var e = l.useContext(Tn);

  if (e === null) {
    var t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, On), t;
  }

  return e;
}

function Rn() {
  var _l$useState13 = l.useState([]),
      _l$useState14 = _slicedToArray(_l$useState13, 2),
      e = _l$useState14[0],
      t = _l$useState14[1];

  return [e.length > 0 ? e.join(" ") : void 0, l.useMemo(function () {
    return function (n) {
      var r = A(function (i) {
        return t(function (a) {
          return [].concat(_toConsumableArray(a), [i]);
        }), function () {
          return t(function (a) {
            var s = a.slice(),
                c = s.indexOf(i);
            return c !== -1 && s.splice(c, 1), s;
          });
        };
      }),
          o = l.useMemo(function () {
        return {
          register: r,
          slot: n.slot,
          name: n.name,
          props: n.props
        };
      }, [r, n.slot, n.name, n.props]);
      return h.default.createElement(Tn.Provider, {
        value: o
      }, n.children);
    };
  }, [t])];
}

var lo = "label",
    so = M(function (e, t) {
  var _e$passive = e.passive,
      n = _e$passive === void 0 ? !1 : _e$passive,
      r = _objectWithoutProperties(e, _excluded8),
      o = On(),
      i = "headlessui-label-".concat(V()),
      a = B(t);

  F(function () {
    return o.register(i);
  }, [i, o.register]);

  var s = _objectSpread(_objectSpread({
    ref: a
  }, o.props), {}, {
    id: i
  });

  return n && ("onClick" in s && delete s.onClick, "onClick" in r && delete r.onClick), H({
    ourProps: s,
    theirProps: r,
    slot: o.slot || {},
    defaultTag: lo,
    name: o.name || "Label"
  });
});

var co = function (e) {
  return e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e;
}(co || {});

var uo = (_uo = {}, _defineProperty(_uo, 0, function _(e, t) {
  var n = [].concat(_toConsumableArray(e.options), [{
    id: t.id,
    element: t.element,
    propsRef: t.propsRef
  }]);
  return _objectSpread(_objectSpread({}, e), {}, {
    options: xe(n, function (r) {
      return r.element.current;
    })
  });
}), _defineProperty(_uo, 1, function _(e, t) {
  var n = e.options.slice(),
      r = e.options.findIndex(function (o) {
    return o.id === t.id;
  });
  return r === -1 ? e : (n.splice(r, 1), _objectSpread(_objectSpread({}, e), {}, {
    options: n
  }));
}), _uo),
    Dt = l.createContext(null);
Dt.displayName = "RadioGroupContext";

function Sn(e) {
  var t = l.useContext(Dt);

  if (t === null) {
    var n = new Error("<".concat(e, " /> is missing a parent <RadioGroup /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(n, Sn), n;
  }

  return t;
}

function fo(e, t) {
  return N(t.type, uo, e, t);
}

var po = "div",
    go = M(function (e, t) {
  var n = e.value,
      r = e.name,
      o = e.onChange,
      _e$disabled3 = e.disabled,
      i = _e$disabled3 === void 0 ? !1 : _e$disabled3,
      a = _objectWithoutProperties(e, _excluded9),
      s = A(function (P, L) {
    return P === L;
  }),
      _l$useReducer = l.useReducer(fo, {
    options: []
  }),
      _l$useReducer2 = _slicedToArray(_l$useReducer, 2),
      c = _l$useReducer2[0],
      u = _l$useReducer2[1],
      d = c.options,
      _Rn = Rn(),
      _Rn2 = _slicedToArray(_Rn, 2),
      f = _Rn2[0],
      p = _Rn2[1],
      _Pn = Pn(),
      _Pn2 = _slicedToArray(_Pn, 2),
      g = _Pn2[0],
      v = _Pn2[1],
      b = "headlessui-radiogroup-".concat(V()),
      m = l.useRef(null),
      x = B(m, t),
      w = l.useMemo(function () {
    return d.find(function (P) {
      return !P.propsRef.current.disabled;
    });
  }, [d]),
      y = l.useMemo(function () {
    return d.some(function (P) {
      return s(P.propsRef.current.value, n);
    });
  }, [d, n]),
      $ = A(function (P) {
    var L;
    if (i || s(P, n)) return !1;
    var D = (L = d.find(function (k) {
      return s(k.propsRef.current.value, P);
    })) == null ? void 0 : L.propsRef.current;
    return D != null && D.disabled ? !1 : (o(P), !0);
  });

  $r({
    container: m.current,
    accept: function accept(P) {
      return P.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : P.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(P) {
      P.setAttribute("role", "none");
    }
  });
  var C = A(function (P) {
    var L = m.current;
    if (!L) return;
    var D = we(L),
        k = d.filter(function (I) {
      return I.propsRef.current.disabled === !1;
    }).map(function (I) {
      return I.element.current;
    });

    switch (P.key) {
      case S.Enter:
        Tr(P.currentTarget);
        break;

      case S.ArrowLeft:
      case S.ArrowUp:
        if (P.preventDefault(), P.stopPropagation(), ne(k, W.Previous | W.WrapAround) === ct.Success) {
          var I = d.find(function (j) {
            return j.element.current === (D == null ? void 0 : D.activeElement);
          });
          I && $(I.propsRef.current.value);
        }

        break;

      case S.ArrowRight:
      case S.ArrowDown:
        if (P.preventDefault(), P.stopPropagation(), ne(k, W.Next | W.WrapAround) === ct.Success) {
          var _I = d.find(function (j) {
            return j.element.current === (D == null ? void 0 : D.activeElement);
          });

          _I && $(_I.propsRef.current.value);
        }

        break;

      case S.Space:
        {
          P.preventDefault(), P.stopPropagation();

          var _I2 = d.find(function (j) {
            return j.element.current === (D == null ? void 0 : D.activeElement);
          });

          _I2 && $(_I2.propsRef.current.value);
        }
        break;
    }
  }),
      E = A(function (P) {
    return u(_objectSpread({
      type: 0
    }, P)), function () {
      return u({
        type: 1,
        id: P.id
      });
    };
  }),
      R = l.useMemo(function () {
    return {
      registerOption: E,
      firstOption: w,
      containsCheckedOption: y,
      change: $,
      disabled: i,
      value: n,
      compare: s
    };
  }, [E, w, y, $, i, n, s]),
      O = {
    ref: x,
    id: b,
    role: "radiogroup",
    "aria-labelledby": f,
    "aria-describedby": g,
    onKeyDown: C
  };
  return h.default.createElement(v, {
    name: "RadioGroup.Description"
  }, h.default.createElement(p, {
    name: "RadioGroup.Label"
  }, h.default.createElement(Dt.Provider, {
    value: R
  }, r != null && n != null && $t(_defineProperty({}, r, n)).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        P = _ref8[0],
        L = _ref8[1];

    return h.default.createElement(Et, _objectSpread({
      features: We.Hidden
    }, Ie({
      key: P,
      as: "input",
      type: "radio",
      checked: L != null,
      hidden: !0,
      readOnly: !0,
      name: P,
      value: L
    })));
  }), H({
    ourProps: O,
    theirProps: a,
    defaultTag: po,
    name: "RadioGroup"
  }))));
});

var mo = function (e) {
  return e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e;
}(mo || {});

var vo = "div",
    bo = M(function (e, t) {
  var n = l.useRef(null),
      r = B(n, t),
      o = "headlessui-radiogroup-option-".concat(V()),
      _Rn3 = Rn(),
      _Rn4 = _slicedToArray(_Rn3, 2),
      i = _Rn4[0],
      a = _Rn4[1],
      _Pn3 = Pn(),
      _Pn4 = _slicedToArray(_Pn3, 2),
      s = _Pn4[0],
      c = _Pn4[1],
      _ao = ao(1),
      u = _ao.addFlag,
      d = _ao.removeFlag,
      f = _ao.hasFlag,
      p = e.value,
      _e$disabled4 = e.disabled,
      g = _e$disabled4 === void 0 ? !1 : _e$disabled4,
      v = _objectWithoutProperties(e, _excluded10),
      b = l.useRef({
    value: p,
    disabled: g
  });

  F(function () {
    b.current.value = p;
  }, [p, b]), F(function () {
    b.current.disabled = g;
  }, [g, b]);

  var _Sn = Sn("RadioGroup.Option"),
      m = _Sn.registerOption,
      x = _Sn.disabled,
      w = _Sn.change,
      y = _Sn.firstOption,
      $ = _Sn.containsCheckedOption,
      C = _Sn.value,
      E = _Sn.compare;

  F(function () {
    return m({
      id: o,
      element: n,
      propsRef: b
    });
  }, [o, m, n, e]);
  var R = A(function () {
    var Y;
    !w(p) || (u(2), (Y = n.current) == null || Y.focus());
  }),
      O = A(function () {
    return u(2);
  }),
      P = A(function () {
    return d(2);
  }),
      L = (y == null ? void 0 : y.id) === o,
      D = x || g,
      k = E(C, p),
      I = {
    ref: r,
    id: o,
    role: "radio",
    "aria-checked": k ? "true" : "false",
    "aria-labelledby": i,
    "aria-describedby": s,
    "aria-disabled": D ? !0 : void 0,
    tabIndex: function () {
      return D ? -1 : k || !$ && L ? 0 : -1;
    }(),
    onClick: D ? void 0 : R,
    onFocus: D ? void 0 : O,
    onBlur: D ? void 0 : P
  },
      j = l.useMemo(function () {
    return {
      checked: k,
      disabled: D,
      active: f(2)
    };
  }, [k, D, f]);
  return h.default.createElement(c, {
    name: "RadioGroup.Description"
  }, h.default.createElement(a, {
    name: "RadioGroup.Label"
  }, H({
    ourProps: I,
    theirProps: v,
    slot: j,
    defaultTag: vo,
    name: "RadioGroup.Option"
  })));
}),
    be = Object.assign(go, {
  Option: bo,
  Label: so,
  Description: Ar
});

function ho(_ref9) {
  var e = _ref9.onFocus;

  var _l$useState15 = l.useState(!0),
      _l$useState16 = _slicedToArray(_l$useState15, 2),
      t = _l$useState16[0],
      n = _l$useState16[1];

  return t ? h.default.createElement(Et, {
    as: "button",
    type: "button",
    features: We.Focusable,
    onFocus: function onFocus(r) {
      r.preventDefault();
      var o,
          i = 50;

      function a() {
        if (i-- <= 0) {
          o && cancelAnimationFrame(o);
          return;
        }

        if (e()) {
          n(!1), cancelAnimationFrame(o);
          return;
        }

        o = requestAnimationFrame(a);
      }

      o = requestAnimationFrame(a);
    }
  }) : null;
}

var xo = function (e) {
  return e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e[e.ForceRerender = 5] = "ForceRerender", e;
}(xo || {});

var yo = (_yo = {}, _defineProperty(_yo, 0, function _(e, t) {
  var n = e.tabs.filter(function (i) {
    var a;
    return !((a = i.current) != null && a.hasAttribute("disabled"));
  });
  if (t.index < 0) return _objectSpread(_objectSpread({}, e), {}, {
    selectedIndex: e.tabs.indexOf(n[0])
  });
  if (t.index > e.tabs.length) return _objectSpread(_objectSpread({}, e), {}, {
    selectedIndex: e.tabs.indexOf(n[n.length - 1])
  });
  var r = e.tabs.slice(0, t.index),
      o = [].concat(_toConsumableArray(e.tabs.slice(t.index)), _toConsumableArray(r)).find(function (i) {
    return n.includes(i);
  });
  return o ? _objectSpread(_objectSpread({}, e), {}, {
    selectedIndex: e.tabs.indexOf(o)
  }) : e;
}), _defineProperty(_yo, 1, function _(e, t) {
  return e.tabs.includes(t.tab) ? e : _objectSpread(_objectSpread({}, e), {}, {
    tabs: xe([].concat(_toConsumableArray(e.tabs), [t.tab]), function (n) {
      return n.current;
    })
  });
}), _defineProperty(_yo, 2, function _(e, t) {
  return _objectSpread(_objectSpread({}, e), {}, {
    tabs: xe(e.tabs.filter(function (n) {
      return n !== t.tab;
    }), function (n) {
      return n.current;
    })
  });
}), _defineProperty(_yo, 3, function _(e, t) {
  return e.panels.includes(t.panel) ? e : _objectSpread(_objectSpread({}, e), {}, {
    panels: [].concat(_toConsumableArray(e.panels), [t.panel])
  });
}), _defineProperty(_yo, 4, function _(e, t) {
  return _objectSpread(_objectSpread({}, e), {}, {
    panels: e.panels.filter(function (n) {
      return n !== t.panel;
    })
  });
}), _defineProperty(_yo, 5, function _(e) {
  return _objectSpread({}, e);
}), _yo),
    Nt = l.createContext(null);
Nt.displayName = "TabsSSRContext";

function Lt(e) {
  var t = l.useContext(Nt);

  if (t === null) {
    var n = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(n, Lt), n;
  }

  return t;
}

var kt = l.createContext(null);
kt.displayName = "TabsDataContext";

function Ee(e) {
  var t = l.useContext(kt);

  if (t === null) {
    var n = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(n, Ee), n;
  }

  return t;
}

var It = l.createContext(null);
It.displayName = "TabsActionsContext";

function Ft(e) {
  var t = l.useContext(It);

  if (t === null) {
    var n = new Error("<".concat(e, " /> is missing a parent <Tab.Group /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(n, Ft), n;
  }

  return t;
}

function wo(e, t) {
  return N(t.type, yo, e, t);
}

var $o = l.Fragment,
    Eo = M(function (e, t) {
  var _e$defaultIndex = e.defaultIndex,
      n = _e$defaultIndex === void 0 ? 0 : _e$defaultIndex,
      _e$vertical = e.vertical,
      r = _e$vertical === void 0 ? !1 : _e$vertical,
      _e$manual = e.manual,
      o = _e$manual === void 0 ? !1 : _e$manual,
      i = e.onChange,
      _e$selectedIndex = e.selectedIndex,
      a = _e$selectedIndex === void 0 ? null : _e$selectedIndex,
      s = _objectWithoutProperties(e, _excluded11);

  var c = r ? "vertical" : "horizontal",
      u = o ? "manual" : "auto";

  var d = B(t),
      _l$useReducer3 = l.useReducer(wo, {
    selectedIndex: a != null ? a : n,
    tabs: [],
    panels: []
  }),
      _l$useReducer4 = _slicedToArray(_l$useReducer3, 2),
      f = _l$useReducer4[0],
      p = _l$useReducer4[1],
      g = l.useMemo(function () {
    return {
      selectedIndex: f.selectedIndex
    };
  }, [f.selectedIndex]),
      v = q(i || function () {}),
      b = q(f.tabs),
      m = l.useMemo(function () {
    return _objectSpread({
      orientation: c,
      activation: u
    }, f);
  }, [c, u, f]),
      x = q(f.selectedIndex),
      w = l.useMemo(function () {
    return {
      registerTab: function registerTab(C) {
        return p({
          type: 1,
          tab: C
        }), function () {
          return p({
            type: 2,
            tab: C
          });
        };
      },
      registerPanel: function registerPanel(C) {
        return p({
          type: 3,
          panel: C
        }), function () {
          return p({
            type: 4,
            panel: C
          });
        };
      },
      forceRerender: function forceRerender() {
        p({
          type: 5
        });
      },
      change: function change(C) {
        x.current !== C && v.current(C), x.current = C, p({
          type: 0,
          index: C
        });
      }
    };
  }, [p]);

  F(function () {
    p({
      type: 0,
      index: a != null ? a : n
    });
  }, [a]);
  var y = l.useRef({
    tabs: [],
    panels: []
  }),
      $ = {
    ref: d
  };
  return h.default.createElement(Nt.Provider, {
    value: y
  }, h.default.createElement(It.Provider, {
    value: w
  }, h.default.createElement(kt.Provider, {
    value: m
  }, m.tabs.length <= 0 && h.default.createElement(ho, {
    onFocus: function onFocus() {
      var C, E;

      var _iterator9 = _createForOfIteratorHelper(b.current),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var R = _step9.value;
          if (((C = R.current) == null ? void 0 : C.tabIndex) === 0) return (E = R.current) == null || E.focus(), !0;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return !1;
    }
  }), H({
    ourProps: $,
    theirProps: s,
    slot: g,
    defaultTag: $o,
    name: "Tabs"
  }))));
}),
    Po = "div",
    Co = M(function (e, t) {
  var _Ee = Ee("Tab.List"),
      n = _Ee.orientation,
      r = _Ee.selectedIndex,
      o = B(t);

  return H({
    ourProps: {
      ref: o,
      role: "tablist",
      "aria-orientation": n
    },
    theirProps: e,
    slot: {
      selectedIndex: r
    },
    defaultTag: Po,
    name: "Tabs.List"
  });
}),
    To = "button",
    Oo = M(function (e, t) {
  var n, r;

  var o = "headlessui-tabs-tab-".concat(V()),
      _Ee2 = Ee("Tab"),
      i = _Ee2.orientation,
      a = _Ee2.activation,
      s = _Ee2.selectedIndex,
      c = _Ee2.tabs,
      u = _Ee2.panels,
      d = Ft("Tab"),
      f = Lt("Tab"),
      p = l.useRef(null),
      g = B(p, t, function (O) {
    !O || d.forceRerender();
  });

  F(function () {
    return d.registerTab(p);
  }, [d, p]);
  var v = f.current.tabs.indexOf(o);
  v === -1 && (v = f.current.tabs.push(o) - 1);
  var b = c.indexOf(p);
  b === -1 && (b = v);
  var m = b === s,
      x = A(function (O) {
    var P = c.map(function (L) {
      return L.current;
    }).filter(Boolean);

    if (O.key === S.Space || O.key === S.Enter) {
      O.preventDefault(), O.stopPropagation(), d.change(b);
      return;
    }

    switch (O.key) {
      case S.Home:
      case S.PageUp:
        return O.preventDefault(), O.stopPropagation(), ne(P, W.First);

      case S.End:
      case S.PageDown:
        return O.preventDefault(), O.stopPropagation(), ne(P, W.Last);
    }

    if (N(i, {
      vertical: function vertical() {
        if (O.key === S.ArrowUp) return ne(P, W.Previous | W.WrapAround);
        if (O.key === S.ArrowDown) return ne(P, W.Next | W.WrapAround);
      },
      horizontal: function horizontal() {
        if (O.key === S.ArrowLeft) return ne(P, W.Previous | W.WrapAround);
        if (O.key === S.ArrowRight) return ne(P, W.Next | W.WrapAround);
      }
    })) return O.preventDefault();
  }),
      w = A(function () {
    var O;
    (O = p.current) == null || O.focus();
  }),
      y = A(function () {
    var O;
    (O = p.current) == null || O.focus(), d.change(b);
  }),
      $ = A(function (O) {
    O.preventDefault();
  }),
      C = l.useMemo(function () {
    return {
      selected: m
    };
  }, [m]),
      E = e,
      R = {
    ref: g,
    onKeyDown: x,
    onFocus: a === "manual" ? w : y,
    onMouseDown: $,
    onClick: y,
    id: o,
    role: "tab",
    type: wt(e, p),
    "aria-controls": (r = (n = u[b]) == null ? void 0 : n.current) == null ? void 0 : r.id,
    "aria-selected": m,
    tabIndex: m ? 0 : -1
  };
  return H({
    ourProps: R,
    theirProps: E,
    slot: C,
    defaultTag: To,
    name: "Tabs.Tab"
  });
}),
    Ro = "div",
    So = M(function (e, t) {
  var _Ee3 = Ee("Tab.Panels"),
      n = _Ee3.selectedIndex,
      r = B(t),
      o = l.useMemo(function () {
    return {
      selectedIndex: n
    };
  }, [n]);

  return H({
    ourProps: {
      ref: r
    },
    theirProps: e,
    slot: o,
    defaultTag: Ro,
    name: "Tabs.Panels"
  });
}),
    Ao = "div",
    Do = re.RenderStrategy | re.Static,
    No = M(function (e, t) {
  var n, r;

  var _Ee4 = Ee("Tab.Panel"),
      o = _Ee4.selectedIndex,
      i = _Ee4.tabs,
      a = _Ee4.panels,
      s = Ft("Tab.Panel"),
      c = Lt("Tab.Panel"),
      u = "headlessui-tabs-panel-".concat(V()),
      d = l.useRef(null),
      f = B(d, t, function (w) {
    !w || s.forceRerender();
  });

  F(function () {
    return s.registerPanel(d);
  }, [s, d]);
  var p = c.current.panels.indexOf(u);
  p === -1 && (p = c.current.panels.push(u) - 1);
  var g = a.indexOf(d);
  g === -1 && (g = p);
  var v = g === o,
      b = l.useMemo(function () {
    return {
      selected: v
    };
  }, [v]),
      m = e,
      x = {
    ref: f,
    id: u,
    role: "tabpanel",
    "aria-labelledby": (r = (n = i[g]) == null ? void 0 : n.current) == null ? void 0 : r.id,
    tabIndex: v ? 0 : -1
  };
  return H({
    ourProps: x,
    theirProps: m,
    slot: b,
    defaultTag: Ao,
    features: Do,
    visible: v,
    name: "Tabs.Panel"
  });
}),
    z = Object.assign(Oo, {
  Group: Eo,
  List: Co,
  Panels: So,
  Panel: No
});

function Lo(e) {
  var t = {
    called: !1
  };
  return function () {
    if (!t.called) return t.called = !0, e.apply(void 0, arguments);
  };
}

function at(e) {
  var _e$classList;

  for (var _len6 = arguments.length, t = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    t[_key6 - 1] = arguments[_key6];
  }

  e && t.length > 0 && (_e$classList = e.classList).add.apply(_e$classList, t);
}

function lt(e) {
  var _e$classList2;

  for (var _len7 = arguments.length, t = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    t[_key7 - 1] = arguments[_key7];
  }

  e && t.length > 0 && (_e$classList2 = e.classList).remove.apply(_e$classList2, t);
}

var ut = function (e) {
  return e.Ended = "ended", e.Cancelled = "cancelled", e;
}(ut || {});

function ko(e, t) {
  var n = se();
  if (!e) return n.dispose;

  var _getComputedStyle = getComputedStyle(e),
      r = _getComputedStyle.transitionDuration,
      o = _getComputedStyle.transitionDelay,
      _map = [r, o].map(function (s) {
    var _s$split$filter$map$s = s.split(",").filter(Boolean).map(function (u) {
      return u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3;
    }).sort(function (u, d) {
      return d - u;
    }),
        _s$split$filter$map$s2 = _slicedToArray(_s$split$filter$map$s, 1),
        _s$split$filter$map$s3 = _s$split$filter$map$s2[0],
        c = _s$split$filter$map$s3 === void 0 ? 0 : _s$split$filter$map$s3;

    return c;
  }),
      _map2 = _slicedToArray(_map, 2),
      i = _map2[0],
      a = _map2[1];

  if (i + a !== 0) {
    var s = [];
    s.push(n.addEventListener(e, "transitionrun", function (c) {
      c.target === c.currentTarget && (s.splice(0).forEach(function (u) {
        return u();
      }), s.push(n.addEventListener(e, "transitionend", function (u) {
        u.target === u.currentTarget && (t("ended"), s.splice(0).forEach(function (d) {
          return d();
        }));
      }), n.addEventListener(e, "transitioncancel", function (u) {
        u.target === u.currentTarget && (t("cancelled"), s.splice(0).forEach(function (d) {
          return d();
        }));
      })));
    }));
  } else t("ended");

  return n.add(function () {
    return t("cancelled");
  }), n.dispose;
}

function Io(e, t, n, r) {
  var o = n ? "enter" : "leave",
      i = se(),
      a = r !== void 0 ? Lo(r) : function () {},
      s = N(o, {
    enter: function enter() {
      return t.enter;
    },
    leave: function leave() {
      return t.leave;
    }
  }),
      c = N(o, {
    enter: function enter() {
      return t.enterTo;
    },
    leave: function leave() {
      return t.leaveTo;
    }
  }),
      u = N(o, {
    enter: function enter() {
      return t.enterFrom;
    },
    leave: function leave() {
      return t.leaveFrom;
    }
  });
  return lt.apply(void 0, [e].concat(_toConsumableArray(t.enter), _toConsumableArray(t.enterTo), _toConsumableArray(t.enterFrom), _toConsumableArray(t.leave), _toConsumableArray(t.leaveFrom), _toConsumableArray(t.leaveTo), _toConsumableArray(t.entered))), at.apply(void 0, [e].concat(_toConsumableArray(s), _toConsumableArray(u))), i.nextFrame(function () {
    lt.apply(void 0, [e].concat(_toConsumableArray(u))), at.apply(void 0, [e].concat(_toConsumableArray(c))), ko(e, function (d) {
      return d === "ended" && (lt.apply(void 0, [e].concat(_toConsumableArray(s))), at.apply(void 0, [e].concat(_toConsumableArray(t.entered)))), a(d);
    });
  }), i.dispose;
}

function Fo(_ref10) {
  var e = _ref10.container,
      t = _ref10.direction,
      n = _ref10.classes,
      r = _ref10.events,
      o = _ref10.onStart,
      i = _ref10.onStop;
  var a = wn(),
      s = ke(),
      c = q(t),
      u = A(function () {
    return N(c.current, {
      enter: function enter() {
        return r.current.beforeEnter();
      },
      leave: function leave() {
        return r.current.beforeLeave();
      },
      idle: function idle() {}
    });
  }),
      d = A(function () {
    return N(c.current, {
      enter: function enter() {
        return r.current.afterEnter();
      },
      leave: function leave() {
        return r.current.afterLeave();
      },
      idle: function idle() {}
    });
  });
  F(function () {
    var f = se();
    s.add(f.dispose);
    var p = e.current;
    if (!!p && c.current !== "idle" && !!a.current) return f.dispose(), u(), o.current(c.current), f.add(Io(p, n.current, c.current === "enter", function (g) {
      var _N10;

      f.dispose(), N(g, (_N10 = {}, _defineProperty(_N10, ut.Ended, function () {
        d(), i.current(c.current);
      }), _defineProperty(_N10, ut.Cancelled, function () {}), _N10));
    })), f.dispose;
  }, [t]);
}

function le() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return e.split(" ").filter(function (t) {
    return t.trim().length > 1;
  });
}

var ze = l.createContext(null);
ze.displayName = "TransitionContext";

var _o = function (e) {
  return e.Visible = "visible", e.Hidden = "hidden", e;
}(_o || {});

function Mo() {
  var e = l.useContext(ze);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}

function Ho() {
  var e = l.useContext(Ge);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}

var Ge = l.createContext(null);
Ge.displayName = "NestingContext";

function qe(e) {
  return "children" in e ? qe(e.children) : e.current.filter(function (_ref11) {
    var t = _ref11.state;
    return t === "visible";
  }).length > 0;
}

function An(e) {
  var t = q(e),
      n = l.useRef([]),
      r = wn(),
      o = A(function (a) {
    var _N11;

    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Z.Hidden;
    var c = n.current.findIndex(function (_ref12) {
      var u = _ref12.id;
      return u === a;
    });
    c !== -1 && (N(s, (_N11 = {}, _defineProperty(_N11, Z.Unmount, function () {
      n.current.splice(c, 1);
    }), _defineProperty(_N11, Z.Hidden, function () {
      n.current[c].state = "hidden";
    }), _N11)), Rr(function () {
      var u;
      !qe(n) && r.current && ((u = t.current) == null || u.call(t));
    }));
  }),
      i = A(function (a) {
    var s = n.current.find(function (_ref13) {
      var c = _ref13.id;
      return c === a;
    });
    return s ? s.state !== "visible" && (s.state = "visible") : n.current.push({
      id: a,
      state: "visible"
    }), function () {
      return o(a, Z.Unmount);
    };
  });
  return l.useMemo(function () {
    return {
      children: n,
      register: i,
      unregister: o
    };
  }, [i, o, n]);
}

function Bo() {}

var jo = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];

function Zt(e) {
  var t;
  var n = {};

  var _iterator10 = _createForOfIteratorHelper(jo),
      _step10;

  try {
    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
      var r = _step10.value;
      n[r] = (t = e[r]) != null ? t : Bo;
    }
  } catch (err) {
    _iterator10.e(err);
  } finally {
    _iterator10.f();
  }

  return n;
}

function Uo(e) {
  var t = l.useRef(Zt(e));
  return l.useEffect(function () {
    t.current = Zt(e);
  }, [e]), t;
}

var Wo = "div",
    Dn = re.RenderStrategy,
    Nn = M(function (e, t) {
  var n = e.beforeEnter,
      r = e.afterEnter,
      o = e.beforeLeave,
      i = e.afterLeave,
      a = e.enter,
      s = e.enterFrom,
      c = e.enterTo,
      u = e.entered,
      d = e.leave,
      f = e.leaveFrom,
      p = e.leaveTo,
      g = _objectWithoutProperties(e, _excluded12),
      v = l.useRef(null),
      b = B(v, t),
      _l$useState17 = l.useState("visible"),
      _l$useState18 = _slicedToArray(_l$useState17, 2),
      m = _l$useState18[0],
      x = _l$useState18[1],
      w = g.unmount ? Z.Unmount : Z.Hidden,
      _Mo = Mo(),
      y = _Mo.show,
      $ = _Mo.appear,
      C = _Mo.initial,
      _Ho = Ho(),
      E = _Ho.register,
      R = _Ho.unregister,
      O = l.useRef(null),
      P = V();

  l.useEffect(function () {
    if (P) return E(P);
  }, [E, P]), l.useEffect(function () {
    if (w === Z.Hidden && !!P) {
      if (y && m !== "visible") {
        x("visible");
        return;
      }

      N(m, {
        hidden: function hidden() {
          return R(P);
        },
        visible: function visible() {
          return E(P);
        }
      });
    }
  }, [m, P, E, R, y, w]);
  var L = q({
    enter: le(a),
    enterFrom: le(s),
    enterTo: le(c),
    entered: le(u),
    leave: le(d),
    leaveFrom: le(f),
    leaveTo: le(p)
  }),
      D = Uo({
    beforeEnter: n,
    afterEnter: r,
    beforeLeave: o,
    afterLeave: i
  }),
      k = xt();
  l.useEffect(function () {
    if (k && m === "visible" && v.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [v, m, k]);

  var I = C && !$,
      j = function () {
    return !k || I || O.current === y ? "idle" : y ? "enter" : "leave";
  }(),
      Y = l.useRef(!1),
      Oe = An(function () {
    Y.current || (x("hidden"), R(P));
  });

  Fo({
    container: v,
    classes: L,
    events: D,
    direction: j,
    onStart: q(function () {
      Y.current = !0;
    }),
    onStop: q(function (Se) {
      Y.current = !1, Se === "leave" && !qe(Oe) && (x("hidden"), R(P));
    })
  }), l.useEffect(function () {
    !I || (w === Z.Hidden ? O.current = null : O.current = y);
  }, [y, I, m]);
  var Re = g,
      Je = {
    ref: b
  };
  return h.default.createElement(Ge.Provider, {
    value: Oe
  }, h.default.createElement(Ct, {
    value: N(m, {
      visible: K.Open,
      hidden: K.Closed
    })
  }, H({
    ourProps: Je,
    theirProps: Re,
    defaultTag: Wo,
    features: Dn,
    visible: m === "visible",
    name: "Transition.Child"
  })));
}),
    dt = M(function (e, t) {
  var _N12;

  var n = e.show,
      _e$appear = e.appear,
      r = _e$appear === void 0 ? !1 : _e$appear,
      o = e.unmount,
      i = _objectWithoutProperties(e, _excluded13),
      a = l.useRef(null),
      s = B(a, t);

  xt();
  var c = Ve();
  if (n === void 0 && c !== null && (n = N(c, (_N12 = {}, _defineProperty(_N12, K.Open, !0), _defineProperty(_N12, K.Closed, !1), _N12))), ![!0, !1].includes(n)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");

  var _l$useState19 = l.useState(n ? "visible" : "hidden"),
      _l$useState20 = _slicedToArray(_l$useState19, 2),
      u = _l$useState20[0],
      d = _l$useState20[1],
      f = An(function () {
    d("hidden");
  }),
      _l$useState21 = l.useState(!0),
      _l$useState22 = _slicedToArray(_l$useState21, 2),
      p = _l$useState22[0],
      g = _l$useState22[1],
      v = l.useRef([n]);

  F(function () {
    p !== !1 && v.current[v.current.length - 1] !== n && (v.current.push(n), g(!1));
  }, [v, n]);
  var b = l.useMemo(function () {
    return {
      show: n,
      appear: r,
      initial: p
    };
  }, [n, r, p]);
  l.useEffect(function () {
    if (n) d("visible");else if (!qe(f)) d("hidden");else {
      var x = a.current;
      if (!x) return;
      var w = x.getBoundingClientRect();
      w.x === 0 && w.y === 0 && w.width === 0 && w.height === 0 && d("hidden");
    }
  }, [n, f]);
  var m = {
    unmount: o
  };
  return h.default.createElement(Ge.Provider, {
    value: f
  }, h.default.createElement(ze.Provider, {
    value: b
  }, H({
    ourProps: _objectSpread(_objectSpread({}, m), {}, {
      as: l.Fragment,
      children: h.default.createElement(Nn, _objectSpread(_objectSpread({
        ref: s
      }, m), i))
    }),
    theirProps: {},
    defaultTag: l.Fragment,
    features: Dn,
    visible: u === "visible",
    name: "Transition"
  })));
}),
    Vo = M(function (e, t) {
  var n = l.useContext(ze) !== null,
      r = Ve() !== null;
  return h.default.createElement(h.default.Fragment, null, !n && r ? h.default.createElement(dt, _objectSpread({
    ref: t
  }, e)) : h.default.createElement(Nn, _objectSpread({
    ref: t
  }, e)));
}),
    Ln = Object.assign(dt, {
  Child: Vo,
  Root: dt
});
var kn = {
  exports: {}
};
/*!
Copyright (c) 2018 Jed Watson.
Licensed under the MIT License (MIT), see
http://jedwatson.github.io/classnames
*/

(function (e) {
  (function () {
    var t = {}.hasOwnProperty;

    function n() {
      for (var r = [], o = 0; o < arguments.length; o++) {
        var i = arguments[o];

        if (!!i) {
          var a = typeof i;
          if (a === "string" || a === "number") r.push(i);else if (Array.isArray(i)) {
            if (i.length) {
              var s = n.apply(null, i);
              s && r.push(s);
            }
          } else if (a === "object") if (i.toString === Object.prototype.toString) for (var c in i) {
            t.call(i, c) && i[c] && r.push(c);
          } else r.push(i.toString());
        }
      }

      return r.join(" ");
    }

    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(kn);

var _ = kn.exports,
    zo = function zo(_ref14) {
  var e = _ref14.description,
      t = _ref14.statusTitle,
      n = _ref14.statusDescription,
      r = _ref14.statusLink,
      o = _ref14.startDate,
      i = _ref14.endDate;
  var a = [{
    label: "Description",
    isDisplay: !0
  }, {
    label: "Status",
    isDisplay: t || n || r
  }];
  return h.default.createElement(h.default.Fragment, null, h.default.createElement("div", {
    className: "gui-flex gui-flex-col md:gui-flex-row gui-text-primaryText"
  }, h.default.createElement(z.Group, {
    as: "div",
    className: "gui-flex-1"
  }, h.default.createElement(z.List, {
    className: "gui-flex gui-space-x-1 gui-border-b-[1px] gui-border-b-borderTabs"
  }, a.map(function (_ref15) {
    var s = _ref15.label,
        c = _ref15.isDisplay;
    return c ? h.default.createElement(z, {
      key: s,
      className: function className(_ref16) {
        var u = _ref16.selected;
        return _("gui-uppercase gui-text-xs gui-py-1 gui-px-4 gui-border-b-2 gui-tracking-widest", "focus:gui-outline-none focus-visible:gui-ring focus-visible:gui-ring-accentColor focus-visible:gui-ring-opacity-75", u ? "gui-text-accentColor gui-border-b-accentColor" : "gui-text-borderTab gui-border-b-borderTab hover:gui-text-accentColor hover:gui-border-b-accentColor");
      }
    }, s) : null;
  })), h.default.createElement(z.Panels, {
    className: "gui-mt-2"
  }, h.default.createElement(z.Panel, {
    className: _("gui-p-1", "focus:gui-outline-none focus-visible:gui-ring focus-visible:gui-ring-accentColor focus-visible:gui-ring-opacity-75")
  }, h.default.createElement("dl", {
    className: "gui-space-y-4"
  }, h.default.createElement("div", null, h.default.createElement("dt", {
    className: "gui-text-sm gui-text-secondaryText gui-leading-5"
  }, "Problem statement / Description"), h.default.createElement("dd", {
    className: "gui-text-sm"
  }, e)))), h.default.createElement(z.Panel, {
    className: _("gui-p-1 gui-text-primaryText", "gui-ring-accentColor gui-ring-opacity-60 gui-ring-offset-1 gui-ring-offset-accentColor focus:gui-outline-none focus:gui-ring-1")
  }, h.default.createElement("dl", {
    className: "gui-space-y-4"
  }, t ? h.default.createElement("div", null, h.default.createElement("dt", {
    className: "gui-text-sm gui-text-secondaryText gui-leading-5"
  }, "Status"), h.default.createElement("dd", {
    className: "gui-text-sm"
  }, t)) : null, n ? h.default.createElement("div", null, h.default.createElement("dt", {
    className: "gui-sr-only"
  }, "Description"), h.default.createElement("dd", {
    className: "gui-text-sm"
  }, n)) : null, r ? h.default.createElement("div", null, h.default.createElement("dt", {
    className: "gui-text-sm gui-text-secondaryText gui-leading-5"
  }, "Read more:"), h.default.createElement("dd", {
    className: "gui-text-sm gui-text-accentColor"
  }, h.default.createElement("a", {
    href: r,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "gui-break-all gui-ring-accentColor focus:gui-outline-none focus:gui-ring-2"
  }, r))) : null)))), h.default.createElement("dl", {
    className: "gui-flex gui-flex-row gui-gap-8 gui-text-sm gui-mt-[26px] gui-px-1 md:gui-px-0 md:gui-pt-4 md:gui-border-t-[1px] md:gui-border-t-borderTabs md:gui-gap-0 md:gui-flex-col md:gui-pl-7 md:gui-basis-[260px] md:gui-min-w-[260px]"
  }, o ? h.default.createElement("div", null, h.default.createElement("dt", {
    className: "gui-text-secondaryText"
  }, "Start Date"), h.default.createElement("dd", null, o)) : null, i ? h.default.createElement("div", null, h.default.createElement("dt", {
    className: "gui-text-secondaryText"
  }, "End Date"), h.default.createElement("dd", null, i)) : null)));
},
    In = function In(e) {
  return T.createElement("svg", _objectSpread({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), T.createElement("path", {
    d: "M.733.5a.7.7 0 0 0-.703.69L0 4.71a.698.698 0 0 0 .962.656.7.7 0 0 0 .438-.647l.026-2.821H12.6v11.184l-2.806.02a.7.7 0 0 0-.487 1.195.701.701 0 0 0 .496.203l3.5-.026a.701.701 0 0 0 .697-.696V1.196A.698.698 0 0 0 13.297.5H.733Zm1.4 6.29a.701.701 0 0 0-.65.966.699.699 0 0 0 .65.433h3.195L.237 13.285a.698.698 0 1 0 .992.986l5.106-5.106v3.213a.698.698 0 0 0 .967.648.7.7 0 0 0 .434-.649v-4.89a.698.698 0 0 0-.703-.697h-4.9Z",
    fill: "currentColor"
  }));
},
    Fn = function Fn(e) {
  return T.createElement("svg", _objectSpread({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e), T.createElement("path", {
    d: "M5.293 9.293a1 1 0 0 1 1.414 0L12 14.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414Z",
    fill: "currentColor"
  }));
},
    Ne = function Ne(_ref17) {
  var e = _ref17.label,
      t = _ref17.value;
  return h.default.createElement("p", {
    className: "gui-flex gui-flex-col"
  }, h.default.createElement("span", {
    className: "gui-text-secondaryText gui-text-sm"
  }, e), h.default.createElement("span", {
    className: "gui-text-primaryText gui-text-sm gui-font-bold"
  }, t));
},
    Go = {
  Completed: "gui-bg-status-completed",
  Ongoing: "gui-bg-status-ongoing",
  Canceled: "gui-bg-status-canceled",
  Default: "gui-bg-status-default"
},
    qo = function qo(e) {
  return h.default.createElement(ot, {
    as: "div",
    className: _(e.theme, "gui-px-0 gui-rounded-r-2xl gui-shadow-card gui-bg-card", e == null ? void 0 : e.className)
  }, function (_ref18) {
    var t = _ref18.open;
    var n;
    return h.default.createElement(h.default.Fragment, null, h.default.createElement(ot.Button, {
      className: _("gui-flex gui-flex-col gui-min-h-[133px] gui-w-full gui-justify-between gui-pr-4 gui-rounded-r-2xl gui-text-left", "focus:gui-outline-none focus-visible:gui-ring focus-visible:gui-ring-accentColor focus-visible:gui-ring-opacity-75", "md:gui-flex-row")
    }, h.default.createElement("div", {
      className: _("gui-relative gui-w-full gui-pl-9 sm:gui-pl-12 gui-flex gui-flex-1 gui-flex-col gui-space-x-4 gui-justify-between gui-py-4", "md:gui-flex-row md:gui-pl-[60px]")
    }, h.default.createElement("div", {
      className: _("gui-absolute gui-left-0 gui-top-[122px] gui-w-[122px] gui-h-[42px] gui-transform gui-rotate-[270deg] gui-origin-top-left gui-rounded-bl-[16px]", "gui-flex gui-items-center gui-justify-center gui-text-status-text gui-font-bold gui-text-xs gui-uppercase gui-tracking-[2px]", Go[(n = e.Status) != null ? n : "Default"])
    }, e.Status), h.default.createElement("div", {
      className: "gui-flex gui-flex-1 gui-pb-8 md:gui-py-0 gui-border-b-dashedBorder gui-border-b-[1px] gui-border-dashed md:gui-border-b-0"
    }, h.default.createElement("div", null, h.default.createElement("span", {
      className: "gui-text-secondaryText gui-text-sm"
    }, "Proposal"), h.default.createElement("h2", {
      className: "gui-text-lg gui-text-primaryText"
    }, e.Project_name), e.origin_link ? h.default.createElement("a", {
      href: e.origin_link,
      target: "_blank",
      onClick: function onClick(r) {
        return r.stopPropagation();
      },
      onKeyDown: function onKeyDown(r) {
        return r.stopPropagation();
      },
      rel: "noopener noreferrer",
      className: _("gui-text-md gui-text-accentColor gui-pointer gui-flex gui-items-center gui-no-underline", "gui-ring-accentColor focus:gui-outline-none focus:gui-ring-2")
    }, "Read More", h.default.createElement(In, {
      className: "gui-w-4 gui-h-4 gui-ml-1 gui-text-linkIcon"
    })) : null)), h.default.createElement("div", {
      className: _("gui-flex gui-flex-1 gui-flex-col", "sm:gui-flex-row sm:gui-space-x-4 gui-py-4", "md:gui-border-l-dashedBorder md:gui-border-l-[1px] md:gui-border-dashed md:gui-pr-4 md:gui-pl-8 md:gui-py-0")
    }, e.Fund ? h.default.createElement("div", {
      className: "gui-flex-1 gui-space-y-1 gui-mb-1 md:gui-mb-0"
    }, h.default.createElement(Ne, {
      label: "Challenge",
      value: e.Category
    }), h.default.createElement(Ne, {
      label: "Fund",
      value: "Fund ".concat(e.Fund)
    })) : null, h.default.createElement("div", {
      className: "gui-flex-1 gui-space-y-1"
    }, e.USD_equivalent && e.Currency ? h.default.createElement(Ne, {
      label: "Amount Requested",
      value: "".concat(e.USD_equivalent, " in ").concat(e.Currency, " ")
    }) : null, e.Project_Lead ? h.default.createElement(Ne, {
      label: "Project Lead",
      value: e.Project_Lead
    }) : null))), h.default.createElement(Fn, {
      className: _("gui-text-arrowIcon gui-transform gui-self-center gui-mb-2 gui-ml-4 md:gui-mb-0 md:gui-ml-0", t && "gui-rotate-[180deg]")
    })), h.default.createElement(Ln, {
      enter: "gui-transition gui-duration-100 gui-ease-out",
      enterFrom: "gui-transform gui-scale-95 gui-opacity-0",
      enterTo: "gui-transform gui-scale-100 gui-opacity-100",
      leave: "gui-transition gui-duration-75 gui-ease-out",
      leaveFrom: "gui-transform gui-scale-100 gui-opacity-100",
      leaveTo: "gui-transform gui-scale-95 gui-opacity-0"
    }, h.default.createElement(ot.Panel, {
      className: "gui-border-t-[1px] gui-border-t-dashedBorder gui-border-dashed gui-ml-12 sm:gui-ml-16 md:gui-ml-[60px] gui-pt-5 gui-pb-6 gui-mr-4"
    }, h.default.createElement(zo, {
      description: e.Description,
      startDate: e.Started_on,
      endDate: e.Completed_on,
      statusTitle: e.Status_title,
      statusDescription: e.Status_description,
      statusLink: e.Status_desc_link1
    }))));
  });
};

function Ko(_ref19) {
  var e = _ref19.label,
      _ref19$hideLabel = _ref19.hideLabel,
      t = _ref19$hideLabel === void 0 ? !1 : _ref19$hideLabel,
      n = _ref19.value,
      r = _ref19.onChange,
      o = _ref19.options,
      i = _ref19.className;
  return T.createElement(ve, {
    value: n,
    onChange: r
  }, T.createElement("div", {
    className: _("gui-relative gui-mt-1", i)
  }, T.createElement(ve.Label, {
    className: _("gui-block gui-pb-1 gui-pl-1 gui-text-select-label gui-font-medium", t ? "gui-sr-only" : "")
  }, e), T.createElement(ve.Button, {
    className: "gui-relative gui-h-14 gui-w-full gui-cursor-default gui-rounded-full gui-bg-select-buttonBg gui-text-select-buttonText gui-py-4 gui-px-6 gui-pr-10 gui-text-left gui-shadow-md focus:gui-outline-none focus-visible:gui-border-accentColor focus-visible:gui-ring-2 focus-visible:gui-ring-accentColor focus-visible:gui-ring-opacity-75 focus-visible:gui-ring-offset-1 focus-visible:gui-ring-offset-accentColor sm:gui-text-sm"
  }, T.createElement("span", {
    className: "gui-block gui-font-medium gui-truncate"
  }, n.label), T.createElement("span", {
    className: "gui-pointer-events-none gui-absolute gui-inset-y-0 gui-right-5 gui-flex gui-items-center gui-pr-2"
  }, T.createElement(Fn, {
    className: "gui-h-5 gui-w-5 gui-text-select-buttonIcon",
    "aria-hidden": "true"
  }))), T.createElement(Ln, {
    as: T.Fragment,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, T.createElement(ve.Options, {
    className: "gui-absolute gui-mt-2 gui-max-h-60 gui-w-full gui-overflow-auto gui-rounded-2xl gui-bg-select-boxBg gui-py-2 gui-text-base gui-shadow-lg gui-ring-1 gui-ring-black gui-ring-opacity-5 focus:gui-outline-none sm:gui-text-sm"
  }, o.map(function (a) {
    return T.createElement(ve.Option, {
      key: a.value,
      className: function className(_ref20) {
        var s = _ref20.active;
        return _("gui-relative gui-cursor-default gui-select-none gui-py-2 gui-pl-6 gui-pr-4", a.disabled ? "gui-bg-select-boxBg gui-text-select-boxText gui-opacity-75 hover:gui-bg-select-boxBg hover:gui-text-select-boxText" : s ? "gui-bg-select-boxBgActive gui-text-select-boxTextActive" : "gui-bg-select-boxBg gui-text-select-boxText gui-transition hover:gui-bg-select-boxBgHover hover:gui-text-select-boxTextHover");
      },
      value: a
    }, function (_ref21) {
      var s = _ref21.selected;
      return T.createElement("span", {
        className: _("block truncate", s ? "gui-font-medium" : "gui-font-normal")
      }, a.label);
    });
  })))));
}

function U() {
  return U = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }, U.apply(this, arguments);
}

function Q(e, t) {
  var _ref22 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref22$checkForDefaul = _ref22.checkForDefaultPrevented,
      n = _ref22$checkForDefaul === void 0 ? !0 : _ref22$checkForDefaul;

  return function (o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented) return t == null ? void 0 : t(o);
  };
}

function Yo(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}

function _n() {
  for (var _len8 = arguments.length, e = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    e[_key8] = arguments[_key8];
  }

  return function (t) {
    return e.forEach(function (n) {
      return Yo(n, t);
    });
  };
}

function fe() {
  for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    e[_key9] = arguments[_key9];
  }

  return l.useCallback(_n.apply(void 0, e), e);
}

function Mn(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var n = [];

  function r(i, a) {
    var s = l.createContext(a),
        c = n.length;
    n = [].concat(_toConsumableArray(n), [a]);

    function u(f) {
      var p = f.scope,
          g = f.children,
          v = _objectWithoutProperties(f, _excluded14),
          b = (p == null ? void 0 : p[e][c]) || s,
          m = l.useMemo(function () {
        return v;
      }, Object.values(v));

      return l.createElement(b.Provider, {
        value: m
      }, g);
    }

    function d(f, p) {
      var g = (p == null ? void 0 : p[e][c]) || s,
          v = l.useContext(g);
      if (v) return v;
      if (a !== void 0) return a;
      throw new Error("`".concat(f, "` must be used within `").concat(i, "`"));
    }

    return u.displayName = i + "Provider", [u, d];
  }

  var o = function o() {
    var i = n.map(function (a) {
      return l.createContext(a);
    });
    return function (s) {
      var c = (s == null ? void 0 : s[e]) || i;
      return l.useMemo(function () {
        return _defineProperty({}, "__scope".concat(e), _objectSpread(_objectSpread({}, s), {}, _defineProperty({}, e, c)));
      }, [s, c]);
    };
  };

  return o.scopeName = e, [r, Xo.apply(void 0, [o].concat(_toConsumableArray(t)))];
}

function Xo() {
  for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
    e[_key10] = arguments[_key10];
  }

  var t = e[0];
  if (e.length === 1) return t;

  var n = function n() {
    var r = e.map(function (o) {
      return {
        useScope: o(),
        scopeName: o.scopeName
      };
    });
    return function (i) {
      var a = r.reduce(function (s, _ref24) {
        var c = _ref24.useScope,
            u = _ref24.scopeName;
        var f = c(i)["__scope".concat(u)];
        return _objectSpread(_objectSpread({}, s), f);
      }, {});
      return l.useMemo(function () {
        return _defineProperty({}, "__scope".concat(t.scopeName), a);
      }, [a]);
    };
  };

  return n.scopeName = t.scopeName, n;
}

var Hn = l.forwardRef(function (e, t) {
  var n = e.children,
      r = _objectWithoutProperties(e, _excluded15),
      o = l.Children.toArray(n),
      i = o.find(Qo);

  if (i) {
    var a = i.props.children,
        s = o.map(function (c) {
      return c === i ? l.Children.count(a) > 1 ? l.Children.only(null) : l.isValidElement(a) ? a.props.children : null : c;
    });
    return l.createElement(ft, U({}, r, {
      ref: t
    }), l.isValidElement(a) ? l.cloneElement(a, void 0, s) : null);
  }

  return l.createElement(ft, U({}, r, {
    ref: t
  }), n);
});
Hn.displayName = "Slot";
var ft = l.forwardRef(function (e, t) {
  var n = e.children,
      r = _objectWithoutProperties(e, _excluded16);

  return l.isValidElement(n) ? l.cloneElement(n, _objectSpread(_objectSpread({}, Zo(r, n.props)), {}, {
    ref: _n(t, n.ref)
  })) : l.Children.count(n) > 1 ? l.Children.only(null) : null;
});
ft.displayName = "SlotClone";

var Bn = function Bn(_ref26) {
  var e = _ref26.children;
  return l.createElement(l.Fragment, null, e);
};

function Qo(e) {
  return l.isValidElement(e) && e.type === Bn;
}

function Zo(e, t) {
  var n = _objectSpread({}, t);

  var _loop3 = function _loop3(r) {
    var o = e[r],
        i = t[r];
    /^on[A-Z]/.test(r) ? n[r] = function () {
      i == null || i.apply(void 0, arguments), o == null || o.apply(void 0, arguments);
    } : r === "style" ? n[r] = _objectSpread(_objectSpread({}, o), i) : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  };

  for (var r in t) {
    _loop3(r);
  }

  return _objectSpread(_objectSpread({}, e), n);
}

var Jo = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"],
    oe = Jo.reduce(function (e, t) {
  var n = l.forwardRef(function (r, o) {
    var i = r.asChild,
        a = _objectWithoutProperties(r, _excluded17),
        s = i ? Hn : t;

    return l.useEffect(function () {
      window[Symbol.for("radix-ui")] = !0;
    }, []), l.createElement(s, U({}, a, {
      ref: o
    }));
  });
  return n.displayName = "Primitive.".concat(t), _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, n));
}, {});

function ei(e, t) {
  e && Ue.flushSync(function () {
    return e.dispatchEvent(t);
  });
}

function Pe(e) {
  var t = l.useRef(e);
  return l.useEffect(function () {
    t.current = e;
  }), l.useMemo(function () {
    return function () {
      var _r3;

      var r;

      for (var _len11 = arguments.length, n = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        n[_key11] = arguments[_key11];
      }

      return (r = t.current) === null || r === void 0 ? void 0 : (_r3 = r).call.apply(_r3, [t].concat(n));
    };
  }, []);
}

function ti(e) {
  var t = Pe(e);
  l.useEffect(function () {
    var n = function n(r) {
      r.key === "Escape" && t(r);
    };

    return document.addEventListener("keydown", n), function () {
      return document.removeEventListener("keydown", n);
    };
  }, [t]);
}

var pt = "dismissableLayer.update",
    ni = "dismissableLayer.pointerDownOutside",
    ri = "dismissableLayer.focusOutside";
var Jt;
var oi = l.createContext({
  layers: new Set(),
  layersWithOutsidePointerEventsDisabled: new Set(),
  branches: new Set()
}),
    ii = l.forwardRef(function (e, t) {
  var _e$disableOutsidePoin = e.disableOutsidePointerEvents,
      n = _e$disableOutsidePoin === void 0 ? !1 : _e$disableOutsidePoin,
      r = e.onEscapeKeyDown,
      o = e.onPointerDownOutside,
      i = e.onFocusOutside,
      a = e.onInteractOutside,
      s = e.onDismiss,
      c = _objectWithoutProperties(e, _excluded18),
      u = l.useContext(oi),
      _l$useState23 = l.useState(null),
      _l$useState24 = _slicedToArray(_l$useState23, 2),
      d = _l$useState24[0],
      f = _l$useState24[1],
      _l$useState25 = l.useState({}),
      _l$useState26 = _slicedToArray(_l$useState25, 2),
      p = _l$useState26[1],
      g = fe(t, function (E) {
    return f(E);
  }),
      v = Array.from(u.layers),
      _slice = _toConsumableArray(u.layersWithOutsidePointerEventsDisabled).slice(-1),
      _slice2 = _slicedToArray(_slice, 1),
      b = _slice2[0],
      m = v.indexOf(b),
      x = d ? v.indexOf(d) : -1,
      w = u.layersWithOutsidePointerEventsDisabled.size > 0,
      y = x >= m,
      $ = ai(function (E) {
    var R = E.target,
        O = _toConsumableArray(u.branches).some(function (P) {
      return P.contains(R);
    });

    !y || O || (o == null || o(E), a == null || a(E), E.defaultPrevented || s == null || s());
  }),
      C = li(function (E) {
    var R = E.target;
    _toConsumableArray(u.branches).some(function (P) {
      return P.contains(R);
    }) || (i == null || i(E), a == null || a(E), E.defaultPrevented || s == null || s());
  });

  return ti(function (E) {
    x === u.layers.size - 1 && (r == null || r(E), !E.defaultPrevented && s && (E.preventDefault(), s()));
  }), l.useEffect(function () {
    if (!!d) return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Jt = document.body.style.pointerEvents, document.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), en(), function () {
      n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (document.body.style.pointerEvents = Jt);
    };
  }, [d, n, u]), l.useEffect(function () {
    return function () {
      !d || (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), en());
    };
  }, [d, u]), l.useEffect(function () {
    var E = function E() {
      return p({});
    };

    return document.addEventListener(pt, E), function () {
      return document.removeEventListener(pt, E);
    };
  }, []), l.createElement(oe.div, U({}, c, {
    ref: g,
    style: _objectSpread({
      pointerEvents: w ? y ? "auto" : "none" : void 0
    }, e.style),
    onFocusCapture: Q(e.onFocusCapture, C.onFocusCapture),
    onBlurCapture: Q(e.onBlurCapture, C.onBlurCapture),
    onPointerDownCapture: Q(e.onPointerDownCapture, $.onPointerDownCapture)
  }));
});

function ai(e) {
  var t = Pe(e),
      n = l.useRef(!1),
      r = l.useRef(function () {});
  return l.useEffect(function () {
    var o = function o(a) {
      if (a.target && !n.current) {
        var c = function c() {
          jn(ni, t, s, {
            discrete: !0
          });
        };

        var s = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (document.removeEventListener("click", r.current), r.current = c, document.addEventListener("click", r.current, {
          once: !0
        })) : c();
      }

      n.current = !1;
    },
        i = window.setTimeout(function () {
      document.addEventListener("pointerdown", o);
    }, 0);

    return function () {
      window.clearTimeout(i), document.removeEventListener("pointerdown", o), document.removeEventListener("click", r.current);
    };
  }, [t]), {
    onPointerDownCapture: function onPointerDownCapture() {
      return n.current = !0;
    }
  };
}

function li(e) {
  var t = Pe(e),
      n = l.useRef(!1);
  return l.useEffect(function () {
    var r = function r(o) {
      o.target && !n.current && jn(ri, t, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };

    return document.addEventListener("focusin", r), function () {
      return document.removeEventListener("focusin", r);
    };
  }, [t]), {
    onFocusCapture: function onFocusCapture() {
      return n.current = !0;
    },
    onBlurCapture: function onBlurCapture() {
      return n.current = !1;
    }
  };
}

function en() {
  var e = new CustomEvent(pt);
  document.dispatchEvent(e);
}

function jn(e, t, n, _ref27) {
  var r = _ref27.discrete;
  var o = n.originalEvent.target,
      i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? ei(o, i) : o.dispatchEvent(i);
}

var de = Boolean(globalThis == null ? void 0 : globalThis.document) ? l.useLayoutEffect : function () {},
    si = T["useId".toString()] || function () {};

var ci = 0;

function ui(e) {
  var _T$useState = T.useState(si()),
      _T$useState2 = _slicedToArray(_T$useState, 2),
      t = _T$useState2[0],
      n = _T$useState2[1];

  return de(function () {
    e || n(function (r) {
      return r != null ? r : String(ci++);
    });
  }, [e]), e || (t ? "radix-".concat(t) : "");
}

function pe(e) {
  return e.split("-")[0];
}

function Ke(e) {
  return e.split("-")[1];
}

function ge(e) {
  return ["top", "bottom"].includes(pe(e)) ? "x" : "y";
}

function _t(e) {
  return e === "y" ? "height" : "width";
}

function tn(e, t, n) {
  var r = e.reference,
      o = e.floating;

  var i = r.x + r.width / 2 - o.width / 2,
      a = r.y + r.height / 2 - o.height / 2,
      s = ge(t),
      c = _t(s),
      u = r[c] / 2 - o[c] / 2,
      d = pe(t),
      f = s === "x";

  var p;

  switch (d) {
    case "top":
      p = {
        x: i,
        y: r.y - o.height
      };
      break;

    case "bottom":
      p = {
        x: i,
        y: r.y + r.height
      };
      break;

    case "right":
      p = {
        x: r.x + r.width,
        y: a
      };
      break;

    case "left":
      p = {
        x: r.x - o.width,
        y: a
      };
      break;

    default:
      p = {
        x: r.x,
        y: r.y
      };
  }

  switch (Ke(t)) {
    case "start":
      p[s] -= u * (n && f ? -1 : 1);
      break;

    case "end":
      p[s] += u * (n && f ? -1 : 1);
      break;
  }

  return p;
}

var di = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t, n) {
    var _n$placement, r, _n$strategy, o, _n$middleware, i, a, s, c, _tn, u, d, f, p, g, v, _i$v, b, m, _yield$m, x, w, y, $, _tn2;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _n$placement = n.placement;
            r = _n$placement === void 0 ? "bottom" : _n$placement;
            _n$strategy = n.strategy;
            o = _n$strategy === void 0 ? "absolute" : _n$strategy;
            _n$middleware = n.middleware;
            i = _n$middleware === void 0 ? [] : _n$middleware;
            a = n.platform;
            _context2.next = 9;
            return a.isRTL == null ? void 0 : a.isRTL(t);

          case 9:
            s = _context2.sent;

            if (!(process.env.NODE_ENV !== "production" && (a == null && console.error(["Floating UI: `platform` property was not passed to config. If you", "want to use Floating UI on the web, install @floating-ui/dom", "instead of the /core package. Otherwise, you can create your own", "`platform`: https://floating-ui.com/docs/platform"].join(" ")), i.filter(function (v) {
              var b = v.name;
              return b === "autoPlacement" || b === "flip";
            }).length > 1))) {
              _context2.next = 12;
              break;
            }

            throw new Error(["Floating UI: duplicate `flip` and/or `autoPlacement`", "middleware detected. This will lead to an infinite loop. Ensure only", "one of either has been passed to the `middleware` array."].join(" "));

          case 12:
            _context2.next = 14;
            return a.getElementRects({
              reference: e,
              floating: t,
              strategy: o
            });

          case 14:
            c = _context2.sent;
            _tn = tn(c, r, s);
            u = _tn.x;
            d = _tn.y;
            f = r;
            p = {};
            g = 0;
            v = 0;

          case 22:
            if (!(v < i.length)) {
              _context2.next = 54;
              break;
            }

            _i$v = i[v];
            b = _i$v.name;
            m = _i$v.fn;
            _context2.next = 28;
            return m({
              x: u,
              y: d,
              initialPlacement: r,
              placement: f,
              strategy: o,
              middlewareData: p,
              rects: c,
              platform: a,
              elements: {
                reference: e,
                floating: t
              }
            });

          case 28:
            _yield$m = _context2.sent;
            x = _yield$m.x;
            w = _yield$m.y;
            y = _yield$m.data;
            $ = _yield$m.reset;

            if (!(u = x != null ? x : u, d = w != null ? w : d, p = _objectSpread(_objectSpread({}, p), {}, _defineProperty({}, b, _objectSpread(_objectSpread({}, p[b]), y))), process.env.NODE_ENV !== "production" && g > 50 && console.warn(["Floating UI: The middleware lifecycle appears to be running in an", "infinite loop. This is usually caused by a `reset` continually", "being returned without a break condition."].join(" ")), $ && g <= 50)) {
              _context2.next = 51;
              break;
            }

            g++;
            _context2.t0 = typeof $ == "object";

            if (!_context2.t0) {
              _context2.next = 49;
              break;
            }

            $.placement && (f = $.placement);
            _context2.t1 = $.rects;

            if (!_context2.t1) {
              _context2.next = 48;
              break;
            }

            if (!($.rects === !0)) {
              _context2.next = 46;
              break;
            }

            _context2.next = 43;
            return a.getElementRects({
              reference: e,
              floating: t,
              strategy: o
            });

          case 43:
            _context2.t2 = _context2.sent;
            _context2.next = 47;
            break;

          case 46:
            _context2.t2 = $.rects;

          case 47:
            c = _context2.t2;

          case 48:
            _tn2 = tn(c, f, s), u = _tn2.x, d = _tn2.y, _tn2;

          case 49:
            v = -1;
            return _context2.abrupt("continue", 51);

          case 51:
            v++;
            _context2.next = 22;
            break;

          case 54:
            return _context2.abrupt("return", {
              x: u,
              y: d,
              placement: f,
              strategy: o,
              middlewareData: p
            });

          case 55:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function di(_x, _x2, _x3) {
    return _ref28.apply(this, arguments);
  };
}();

function fi(e) {
  return _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, e);
}

function Un(e) {
  return typeof e != "number" ? fi(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}

function Fe(e) {
  return _objectSpread(_objectSpread({}, e), {}, {
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}

function _e(_x4, _x5) {
  return _e3.apply(this, arguments);
}

function _e3() {
  _e3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e, t) {
    var n, r, o, i, a, s, c, _t2, _t2$boundary, u, _t2$rootBoundary, d, _t2$elementContext, f, _t2$altBoundary, p, _t2$padding, g, v, m, x, w;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            t === void 0 && (t = {});
            r = e.x;
            o = e.y;
            i = e.platform;
            a = e.rects;
            s = e.elements;
            c = e.strategy;
            _t2 = t;
            _t2$boundary = _t2.boundary;
            u = _t2$boundary === void 0 ? "clippingAncestors" : _t2$boundary;
            _t2$rootBoundary = _t2.rootBoundary;
            d = _t2$rootBoundary === void 0 ? "viewport" : _t2$rootBoundary;
            _t2$elementContext = _t2.elementContext;
            f = _t2$elementContext === void 0 ? "floating" : _t2$elementContext;
            _t2$altBoundary = _t2.altBoundary;
            p = _t2$altBoundary === void 0 ? !1 : _t2$altBoundary;
            _t2$padding = _t2.padding;
            g = _t2$padding === void 0 ? 0 : _t2$padding;
            v = Un(g);
            m = s[p ? f === "floating" ? "reference" : "floating" : f];
            _context8.t0 = Fe;
            _context8.t1 = i;
            _context8.next = 24;
            return i.isElement == null ? void 0 : i.isElement(m);

          case 24:
            _context8.t3 = n = _context8.sent;
            _context8.t2 = _context8.t3 == null;

            if (_context8.t2) {
              _context8.next = 28;
              break;
            }

            _context8.t2 = n;

          case 28:
            if (!_context8.t2) {
              _context8.next = 32;
              break;
            }

            _context8.t4 = m;
            _context8.next = 38;
            break;

          case 32:
            _context8.t5 = m.contextElement;

            if (_context8.t5) {
              _context8.next = 37;
              break;
            }

            _context8.next = 36;
            return i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating);

          case 36:
            _context8.t5 = _context8.sent;

          case 37:
            _context8.t4 = _context8.t5;

          case 38:
            _context8.t6 = _context8.t4;
            _context8.t7 = u;
            _context8.t8 = d;
            _context8.t9 = c;
            _context8.t10 = {
              element: _context8.t6,
              boundary: _context8.t7,
              rootBoundary: _context8.t8,
              strategy: _context8.t9
            };
            _context8.next = 45;
            return _context8.t1.getClippingRect.call(_context8.t1, _context8.t10);

          case 45:
            _context8.t11 = _context8.sent;
            x = (0, _context8.t0)(_context8.t11);
            _context8.t12 = Fe;

            if (!i.convertOffsetParentRelativeRectToViewportRelativeRect) {
              _context8.next = 61;
              break;
            }

            _context8.t14 = i;
            _context8.t15 = f === "floating" ? _objectSpread(_objectSpread({}, a.floating), {}, {
              x: r,
              y: o
            }) : a.reference;
            _context8.next = 53;
            return i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating);

          case 53:
            _context8.t16 = _context8.sent;
            _context8.t17 = c;
            _context8.t18 = {
              rect: _context8.t15,
              offsetParent: _context8.t16,
              strategy: _context8.t17
            };
            _context8.next = 58;
            return _context8.t14.convertOffsetParentRelativeRectToViewportRelativeRect.call(_context8.t14, _context8.t18);

          case 58:
            _context8.t13 = _context8.sent;
            _context8.next = 62;
            break;

          case 61:
            _context8.t13 = a[f];

          case 62:
            _context8.t19 = _context8.t13;
            w = (0, _context8.t12)(_context8.t19);
            return _context8.abrupt("return", {
              top: x.top - w.top + v.top,
              bottom: w.bottom - x.bottom + v.bottom,
              left: x.left - w.left + v.left,
              right: w.right - x.right + v.right
            });

          case 65:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _e3.apply(this, arguments);
}

var pi = Math.min,
    gi = Math.max;

function gt(e, t, n) {
  return gi(e, pi(t, n));
}

var nn = function nn(e) {
  return {
    name: "arrow",
    options: e,
    fn: function fn(t) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _data, _ref30;

        var _ref29, n, _ref29$padding, r, o, i, a, s, c, u, d, f, p, g, v, b, m, x, w, y, $, C, E, R, O, P, k;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref29 = e != null ? e : {}, n = _ref29.element, _ref29$padding = _ref29.padding, r = _ref29$padding === void 0 ? 0 : _ref29$padding, o = t.x, i = t.y, a = t.placement, s = t.rects, c = t.platform;

                if (!(n == null)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", (process.env.NODE_ENV !== "production" && console.warn("Floating UI: No `element` was passed to the `arrow` middleware."), {}));

              case 3:
                u = Un(r);
                d = {
                  x: o,
                  y: i
                };
                f = ge(a);
                p = Ke(a);
                g = _t(f);
                _context3.next = 10;
                return c.getDimensions(n);

              case 10:
                v = _context3.sent;
                b = f === "y" ? "top" : "left";
                m = f === "y" ? "bottom" : "right";
                x = s.reference[g] + s.reference[f] - d[f] - s.floating[g];
                w = d[f] - s.reference[f];
                _context3.next = 17;
                return c.getOffsetParent == null ? void 0 : c.getOffsetParent(n);

              case 17:
                y = _context3.sent;
                $ = y ? f === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0;
                $ === 0 && ($ = s.floating[g]);
                C = x / 2 - w / 2, E = u[b], R = $ - v[g] - u[m], O = $ / 2 - v[g] / 2 + C, P = gt(E, O, R), k = (p === "start" ? u[b] : u[m]) > 0 && O !== P && s.reference[g] <= s.floating[g] ? O < E ? E - O : R - O : 0;
                return _context3.abrupt("return", (_ref30 = {}, _defineProperty(_ref30, f, d[f] - k), _defineProperty(_ref30, "data", (_data = {}, _defineProperty(_data, f, P), _defineProperty(_data, "centerOffset", O - P), _data)), _ref30));

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  };
},
    mi = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};

function Me(e) {
  return e.replace(/left|right|bottom|top/g, function (t) {
    return mi[t];
  });
}

function vi(e, t, n) {
  n === void 0 && (n = !1);

  var r = Ke(e),
      o = ge(e),
      i = _t(o);

  var a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Me(a)), {
    main: a,
    cross: Me(a)
  };
}

var bi = {
  start: "end",
  end: "start"
};

function rn(e) {
  return e.replace(/start|end/g, function (t) {
    return bi[t];
  });
}

var hi = ["top", "right", "bottom", "left"];

function xi(e) {
  var t = Me(e);
  return [rn(e), t, rn(t)];
}

var yi = function yi(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    fn: function fn(t) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var n, r, o, i, a, s, c, _e4, _e4$mainAxis, u, _e4$crossAxis, d, f, _e4$fallbackStrategy, p, _e4$flipAlignment, g, v, b, x, w, y, $, C, _vi, P, L, E, R, _P, _L, D, O, k;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                r = t.placement;
                o = t.middlewareData;
                i = t.rects;
                a = t.initialPlacement;
                s = t.platform;
                c = t.elements;
                _e4 = e;
                _e4$mainAxis = _e4.mainAxis;
                u = _e4$mainAxis === void 0 ? !0 : _e4$mainAxis;
                _e4$crossAxis = _e4.crossAxis;
                d = _e4$crossAxis === void 0 ? !0 : _e4$crossAxis;
                f = _e4.fallbackPlacements;
                _e4$fallbackStrategy = _e4.fallbackStrategy;
                p = _e4$fallbackStrategy === void 0 ? "bestFit" : _e4$fallbackStrategy;
                _e4$flipAlignment = _e4.flipAlignment;
                g = _e4$flipAlignment === void 0 ? !0 : _e4$flipAlignment;
                v = _objectWithoutProperties(_e4, _excluded19);
                b = pe(r);
                x = f || (b === a || !g ? [Me(a)] : xi(a));
                w = [a].concat(_toConsumableArray(x));
                _context4.next = 22;
                return _e(t, v);

              case 22:
                y = _context4.sent;
                $ = [];
                C = ((n = o.flip) == null ? void 0 : n.overflows) || [];

                if (!(u && $.push(y[b]), d)) {
                  _context4.next = 36;
                  break;
                }

                _context4.t0 = vi;
                _context4.t1 = r;
                _context4.t2 = i;
                _context4.next = 31;
                return s.isRTL == null ? void 0 : s.isRTL(c.floating);

              case 31:
                _context4.t3 = _context4.sent;
                _vi = (0, _context4.t0)(_context4.t1, _context4.t2, _context4.t3);
                P = _vi.main;
                L = _vi.cross;
                $.push(y[P], y[L]);

              case 36:
                if (!(C = [].concat(_toConsumableArray(C), [{
                  placement: r,
                  overflows: $
                }]), !$.every(function (P) {
                  return P <= 0;
                }))) {
                  _context4.next = 51;
                  break;
                }

                _P = ((E = (R = o.flip) == null ? void 0 : R.index) != null ? E : 0) + 1, _L = w[_P];

                if (!_L) {
                  _context4.next = 40;
                  break;
                }

                return _context4.abrupt("return", {
                  data: {
                    index: _P,
                    overflows: C
                  },
                  reset: {
                    placement: _L
                  }
                });

              case 40:
                D = "bottom";
                _context4.t4 = p;
                _context4.next = _context4.t4 === "bestFit" ? 44 : _context4.t4 === "initialPlacement" ? 47 : 49;
                break;

              case 44:
                k = (O = C.map(function (I) {
                  return [I, I.overflows.filter(function (j) {
                    return j > 0;
                  }).reduce(function (j, Y) {
                    return j + Y;
                  }, 0)];
                }).sort(function (I, j) {
                  return I[1] - j[1];
                })[0]) == null ? void 0 : O[0].placement;
                k && (D = k);
                return _context4.abrupt("break", 49);

              case 47:
                D = a;
                return _context4.abrupt("break", 49);

              case 49:
                if (!(r !== D)) {
                  _context4.next = 51;
                  break;
                }

                return _context4.abrupt("return", {
                  reset: {
                    placement: D
                  }
                });

              case 51:
                return _context4.abrupt("return", {});

              case 52:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  };
};

function on(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}

function an(e) {
  return hi.some(function (t) {
    return e[t] >= 0;
  });
}

var wi = function wi(e) {
  var _ref31 = e === void 0 ? {} : e,
      _ref31$strategy = _ref31.strategy,
      t = _ref31$strategy === void 0 ? "referenceHidden" : _ref31$strategy,
      n = _objectWithoutProperties(_ref31, _excluded20);

  return {
    name: "hide",
    fn: function fn(r) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var o, i, a, _i4, _a3;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                o = r.rects;
                _context5.t0 = t;
                _context5.next = _context5.t0 === "referenceHidden" ? 4 : _context5.t0 === "escaped" ? 9 : 14;
                break;

              case 4:
                _context5.next = 6;
                return _e(r, _objectSpread(_objectSpread({}, n), {}, {
                  elementContext: "reference"
                }));

              case 6:
                i = _context5.sent;
                a = on(i, o.reference);
                return _context5.abrupt("return", {
                  data: {
                    referenceHiddenOffsets: a,
                    referenceHidden: an(a)
                  }
                });

              case 9:
                _context5.next = 11;
                return _e(r, _objectSpread(_objectSpread({}, n), {}, {
                  altBoundary: !0
                }));

              case 11:
                _i4 = _context5.sent;
                _a3 = on(_i4, o.floating);
                return _context5.abrupt("return", {
                  data: {
                    escapedOffsets: _a3,
                    escaped: an(_a3)
                  }
                });

              case 14:
                return _context5.abrupt("return", {});

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  };
};

function $i(_x6, _x7) {
  return _$i.apply(this, arguments);
}

function _$i() {
  _$i = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e, t) {
    var n, r, o, i, a, s, c, u, d, f, _ref45, p, g, v;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            n = e.placement;
            r = e.platform;
            o = e.elements;
            _context9.next = 5;
            return r.isRTL == null ? void 0 : r.isRTL(o.floating);

          case 5:
            i = _context9.sent;
            a = pe(n);
            s = Ke(n);
            c = ge(n) === "x";
            u = ["left", "top"].includes(a) ? -1 : 1;
            d = i && c ? -1 : 1;
            f = typeof t == "function" ? t(e) : t;
            _ref45 = typeof f == "number" ? {
              mainAxis: f,
              crossAxis: 0,
              alignmentAxis: null
            } : _objectSpread({
              mainAxis: 0,
              crossAxis: 0,
              alignmentAxis: null
            }, f), p = _ref45.mainAxis, g = _ref45.crossAxis, v = _ref45.alignmentAxis;
            return _context9.abrupt("return", (s && typeof v == "number" && (g = s === "end" ? v * -1 : v), c ? {
              x: g * d,
              y: p * u
            } : {
              x: p * u,
              y: g * d
            }));

          case 14:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _$i.apply(this, arguments);
}

var Ei = function Ei(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    fn: function fn(t) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var n, r, o;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                n = t.x;
                r = t.y;
                _context6.next = 4;
                return $i(t, e);

              case 4:
                o = _context6.sent;
                return _context6.abrupt("return", {
                  x: n + o.x,
                  y: r + o.y,
                  data: o
                });

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  };
};

function Wn(e) {
  return e === "x" ? "y" : "x";
}

var Pi = function Pi(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    fn: function fn(t) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _objectSpread5;

        var n, r, o, _e5, _e5$mainAxis, i, _e5$crossAxis, a, _e5$limiter, s, c, u, d, f, p, g, v, m, x, w, y, _m, _x8, _w, _y, b;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                n = t.x;
                r = t.y;
                o = t.placement;
                _e5 = e;
                _e5$mainAxis = _e5.mainAxis;
                i = _e5$mainAxis === void 0 ? !0 : _e5$mainAxis;
                _e5$crossAxis = _e5.crossAxis;
                a = _e5$crossAxis === void 0 ? !1 : _e5$crossAxis;
                _e5$limiter = _e5.limiter;
                s = _e5$limiter === void 0 ? {
                  fn: function fn(m) {
                    var x = m.x,
                        w = m.y;
                    return {
                      x: x,
                      y: w
                    };
                  }
                } : _e5$limiter;
                c = _objectWithoutProperties(_e5, _excluded21);
                u = {
                  x: n,
                  y: r
                };
                _context7.next = 14;
                return _e(t, c);

              case 14:
                d = _context7.sent;
                f = ge(pe(o));
                p = Wn(f);
                g = u[f], v = u[p];

                if (i) {
                  m = f === "y" ? "top" : "left", x = f === "y" ? "bottom" : "right", w = g + d[m], y = g - d[x];
                  g = gt(w, g, y);
                }

                if (a) {
                  _m = p === "y" ? "top" : "left", _x8 = p === "y" ? "bottom" : "right", _w = v + d[_m], _y = v - d[_x8];
                  v = gt(_w, v, _y);
                }

                b = s.fn(_objectSpread(_objectSpread({}, t), {}, (_objectSpread5 = {}, _defineProperty(_objectSpread5, f, g), _defineProperty(_objectSpread5, p, v), _objectSpread5)));
                return _context7.abrupt("return", _objectSpread(_objectSpread({}, b), {}, {
                  data: {
                    x: b.x - n,
                    y: b.y - r
                  }
                }));

              case 22:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  };
},
    Ci = function Ci(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn: function fn(t) {
      var _ref32;

      var n = t.x,
          r = t.y,
          o = t.placement,
          i = t.rects,
          a = t.middlewareData,
          _e6 = e,
          _e6$offset = _e6.offset,
          s = _e6$offset === void 0 ? 0 : _e6$offset,
          _e6$mainAxis = _e6.mainAxis,
          c = _e6$mainAxis === void 0 ? !0 : _e6$mainAxis,
          _e6$crossAxis = _e6.crossAxis,
          u = _e6$crossAxis === void 0 ? !0 : _e6$crossAxis,
          d = {
        x: n,
        y: r
      },
          f = ge(o),
          p = Wn(f);
      var g = d[f],
          v = d[p];
      var b = typeof s == "function" ? s(_objectSpread(_objectSpread({}, i), {}, {
        placement: o
      })) : s,
          m = typeof b == "number" ? {
        mainAxis: b,
        crossAxis: 0
      } : _objectSpread({
        mainAxis: 0,
        crossAxis: 0
      }, b);

      if (c) {
        var C = f === "y" ? "height" : "width",
            E = i.reference[f] - i.floating[C] + m.mainAxis,
            R = i.reference[f] + i.reference[C] - m.mainAxis;
        g < E ? g = E : g > R && (g = R);
      }

      if (u) {
        var x, w, y, $;

        var _C = f === "y" ? "width" : "height",
            _E = ["top", "left"].includes(pe(o)),
            _R = i.reference[p] - i.floating[_C] + (_E && (x = (w = a.offset) == null ? void 0 : w[p]) != null ? x : 0) + (_E ? 0 : m.crossAxis),
            O = i.reference[p] + i.reference[_C] + (_E ? 0 : (y = ($ = a.offset) == null ? void 0 : $[p]) != null ? y : 0) - (_E ? m.crossAxis : 0);

        v < _R ? v = _R : v > O && (v = O);
      }

      return _ref32 = {}, _defineProperty(_ref32, f, g), _defineProperty(_ref32, p, v), _ref32;
    }
  };
};

function Vn(e) {
  return e && e.document && e.location && e.alert && e.setInterval;
}

function te(e) {
  if (e == null) return window;

  if (!Vn(e)) {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }

  return e;
}

function Ce(e) {
  return te(e).getComputedStyle(e);
}

function J(e) {
  return Vn(e) ? "" : e ? (e.nodeName || "").toLowerCase() : "";
}

function zn() {
  var e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map(function (t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}

function X(e) {
  return e instanceof te(e).HTMLElement;
}

function ie(e) {
  return e instanceof te(e).Element;
}

function Ti(e) {
  return e instanceof te(e).Node;
}

function Mt(e) {
  if (typeof ShadowRoot > "u") return !1;
  var t = te(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}

function Ye(e) {
  var _Ce = Ce(e),
      t = _Ce.overflow,
      n = _Ce.overflowX,
      r = _Ce.overflowY;

  return /auto|scroll|overlay|hidden/.test(t + r + n);
}

function Oi(e) {
  return ["table", "td", "th"].includes(J(e));
}

function Gn(e) {
  var t = /firefox/i.test(zn()),
      n = Ce(e);
  return n.transform !== "none" || n.perspective !== "none" || n.contain === "paint" || ["transform", "perspective"].includes(n.willChange) || t && n.willChange === "filter" || t && (n.filter ? n.filter !== "none" : !1);
}

function qn() {
  return !/^((?!chrome|android).)*safari/i.test(zn());
}

var ln = Math.min,
    he = Math.max,
    He = Math.round;

function ee(e, t, n) {
  var r, o, i, a;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var s = e.getBoundingClientRect();
  var c = 1,
      u = 1;
  t && X(e) && (c = e.offsetWidth > 0 && He(s.width) / e.offsetWidth || 1, u = e.offsetHeight > 0 && He(s.height) / e.offsetHeight || 1);
  var d = ie(e) ? te(e) : window,
      f = !qn() && n,
      p = (s.left + (f && (r = (o = d.visualViewport) == null ? void 0 : o.offsetLeft) != null ? r : 0)) / c,
      g = (s.top + (f && (i = (a = d.visualViewport) == null ? void 0 : a.offsetTop) != null ? i : 0)) / u,
      v = s.width / c,
      b = s.height / u;
  return {
    width: v,
    height: b,
    top: g,
    right: p + v,
    bottom: g + b,
    left: p,
    x: p,
    y: g
  };
}

function ae(e) {
  return ((Ti(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}

function Xe(e) {
  return ie(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}

function Kn(e) {
  return ee(ae(e)).left + Xe(e).scrollLeft;
}

function Ri(e) {
  var t = ee(e);
  return He(t.width) !== e.offsetWidth || He(t.height) !== e.offsetHeight;
}

function Si(e, t, n) {
  var r = X(t),
      o = ae(t),
      i = ee(e, r && Ri(t), n === "fixed");
  var a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var s = {
    x: 0,
    y: 0
  };
  if (r || !r && n !== "fixed") if ((J(t) !== "body" || Ye(o)) && (a = Xe(t)), X(t)) {
    var c = ee(t, !0);
    s.x = c.x + t.clientLeft, s.y = c.y + t.clientTop;
  } else o && (s.x = Kn(o));
  return {
    x: i.left + a.scrollLeft - s.x,
    y: i.top + a.scrollTop - s.y,
    width: i.width,
    height: i.height
  };
}

function Yn(e) {
  return J(e) === "html" ? e : e.assignedSlot || e.parentNode || (Mt(e) ? e.host : null) || ae(e);
}

function sn(e) {
  return !X(e) || getComputedStyle(e).position === "fixed" ? null : e.offsetParent;
}

function Ai(e) {
  var t = Yn(e);

  for (Mt(t) && (t = t.host); X(t) && !["html", "body"].includes(J(t));) {
    if (Gn(t)) return t;
    t = t.parentNode;
  }

  return null;
}

function mt(e) {
  var t = te(e);
  var n = sn(e);

  for (; n && Oi(n) && getComputedStyle(n).position === "static";) {
    n = sn(n);
  }

  return n && (J(n) === "html" || J(n) === "body" && getComputedStyle(n).position === "static" && !Gn(n)) ? t : n || Ai(e) || t;
}

function cn(e) {
  if (X(e)) return {
    width: e.offsetWidth,
    height: e.offsetHeight
  };
  var t = ee(e);
  return {
    width: t.width,
    height: t.height
  };
}

function Di(e) {
  var t = e.rect,
      n = e.offsetParent,
      r = e.strategy;
  var o = X(n),
      i = ae(n);
  if (n === i) return t;
  var a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var s = {
    x: 0,
    y: 0
  };

  if ((o || !o && r !== "fixed") && ((J(n) !== "body" || Ye(i)) && (a = Xe(n)), X(n))) {
    var c = ee(n, !0);
    s.x = c.x + n.clientLeft, s.y = c.y + n.clientTop;
  }

  return _objectSpread(_objectSpread({}, t), {}, {
    x: t.x - a.scrollLeft + s.x,
    y: t.y - a.scrollTop + s.y
  });
}

function Ni(e, t) {
  var n = te(e),
      r = ae(e),
      o = n.visualViewport;
  var i = r.clientWidth,
      a = r.clientHeight,
      s = 0,
      c = 0;

  if (o) {
    i = o.width, a = o.height;
    var u = qn();
    (u || !u && t === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }

  return {
    width: i,
    height: a,
    x: s,
    y: c
  };
}

function Li(e) {
  var t;
  var n = ae(e),
      r = Xe(e),
      o = (t = e.ownerDocument) == null ? void 0 : t.body,
      i = he(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0),
      a = he(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0);
  var s = -r.scrollLeft + Kn(e);
  var c = -r.scrollTop;
  return Ce(o || n).direction === "rtl" && (s += he(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: s,
    y: c
  };
}

function Xn(e) {
  var t = Yn(e);
  return ["html", "body", "#document"].includes(J(t)) ? e.ownerDocument.body : X(t) && Ye(t) ? t : Xn(t);
}

function Be(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = Xn(e),
      o = r === ((n = e.ownerDocument) == null ? void 0 : n.body),
      i = te(r),
      a = o ? [i].concat(i.visualViewport || [], Ye(r) ? r : []) : r,
      s = t.concat(a);
  return o ? s : s.concat(Be(a));
}

function ki(e, t) {
  var n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t)) return !0;

  if (n && Mt(n)) {
    var r = t;

    do {
      if (r && e === r) return !0;
      r = r.parentNode || r.host;
    } while (r);
  }

  return !1;
}

function Ii(e, t) {
  var n = ee(e, !1, t === "fixed"),
      r = n.top + e.clientTop,
      o = n.left + e.clientLeft;
  return {
    top: r,
    left: o,
    x: o,
    y: r,
    right: o + e.clientWidth,
    bottom: r + e.clientHeight,
    width: e.clientWidth,
    height: e.clientHeight
  };
}

function un(e, t, n) {
  return t === "viewport" ? Fe(Ni(e, n)) : ie(t) ? Ii(t, n) : Fe(Li(ae(e)));
}

function Fi(e) {
  var t = Be(e),
      r = ["absolute", "fixed"].includes(Ce(e).position) && X(e) ? mt(e) : e;
  return ie(r) ? t.filter(function (o) {
    return ie(o) && ki(o, r) && J(o) !== "body";
  }) : [];
}

function _i(e) {
  var t = e.element,
      n = e.boundary,
      r = e.rootBoundary,
      o = e.strategy;
  var a = [].concat(_toConsumableArray(n === "clippingAncestors" ? Fi(t) : [].concat(n)), [r]),
      s = a[0],
      c = a.reduce(function (u, d) {
    var f = un(t, d, o);
    return u.top = he(f.top, u.top), u.right = ln(f.right, u.right), u.bottom = ln(f.bottom, u.bottom), u.left = he(f.left, u.left), u;
  }, un(t, s, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}

var Mi = {
  getClippingRect: _i,
  convertOffsetParentRelativeRectToViewportRelativeRect: Di,
  isElement: ie,
  getDimensions: cn,
  getOffsetParent: mt,
  getDocumentElement: ae,
  getElementRects: function getElementRects(e) {
    var t = e.reference,
        n = e.floating,
        r = e.strategy;
    return {
      reference: Si(t, mt(n), r),
      floating: _objectSpread(_objectSpread({}, cn(n)), {}, {
        x: 0,
        y: 0
      })
    };
  },
  getClientRects: function getClientRects(e) {
    return Array.from(e.getClientRects());
  },
  isRTL: function isRTL(e) {
    return Ce(e).direction === "rtl";
  }
};

function Hi(e, t, n, r) {
  r === void 0 && (r = {});
  var _r4 = r,
      _r4$ancestorScroll = _r4.ancestorScroll,
      o = _r4$ancestorScroll === void 0 ? !0 : _r4$ancestorScroll,
      _r4$ancestorResize = _r4.ancestorResize,
      i = _r4$ancestorResize === void 0 ? !0 : _r4$ancestorResize,
      _r4$elementResize = _r4.elementResize,
      a = _r4$elementResize === void 0 ? !0 : _r4$elementResize,
      _r4$animationFrame = _r4.animationFrame,
      s = _r4$animationFrame === void 0 ? !1 : _r4$animationFrame,
      c = o && !s,
      u = i && !s,
      d = c || u ? [].concat(_toConsumableArray(ie(e) ? Be(e) : []), _toConsumableArray(Be(t))) : [];
  d.forEach(function (b) {
    c && b.addEventListener("scroll", n, {
      passive: !0
    }), u && b.addEventListener("resize", n);
  });
  var f = null;

  if (a) {
    var b = !0;
    f = new ResizeObserver(function () {
      b || n(), b = !1;
    }), ie(e) && !s && f.observe(e), f.observe(t);
  }

  var p,
      g = s ? ee(e) : null;
  s && v();

  function v() {
    var b = ee(e);
    g && (b.x !== g.x || b.y !== g.y || b.width !== g.width || b.height !== g.height) && n(), g = b, p = requestAnimationFrame(v);
  }

  return n(), function () {
    var b;
    d.forEach(function (m) {
      c && m.removeEventListener("scroll", n), u && m.removeEventListener("resize", n);
    }), (b = f) == null || b.disconnect(), f = null, s && cancelAnimationFrame(p);
  };
}

var Bi = function Bi(e, t, n) {
  return di(e, t, _objectSpread({
    platform: Mi
  }, n));
};

var vt = typeof document < "u" ? l.useLayoutEffect : l.useEffect;

function bt(e, t) {
  if (e === t) return !0;
  if (typeof e != typeof t) return !1;
  if (typeof e == "function" && e.toString() === t.toString()) return !0;
  var n, r, o;

  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length) return !1;

      for (r = n; r-- !== 0;) {
        if (!bt(e[r], t[r])) return !1;
      }

      return !0;
    }

    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length) return !1;

    for (r = n; r-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(t, o[r])) return !1;
    }

    for (r = n; r-- !== 0;) {
      var i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !bt(e[i], t[i])) return !1;
    }

    return !0;
  }

  return e !== e && t !== t;
}

function ji(e) {
  var t = T.useRef(e);
  return vt(function () {
    t.current = e;
  }), t;
}

function Ui(e) {
  var _ref33 = e === void 0 ? {} : e,
      t = _ref33.middleware,
      _ref33$placement = _ref33.placement,
      n = _ref33$placement === void 0 ? "bottom" : _ref33$placement,
      _ref33$strategy = _ref33.strategy,
      r = _ref33$strategy === void 0 ? "absolute" : _ref33$strategy,
      o = _ref33.whileElementsMounted;

  var i = T.useRef(null),
      a = T.useRef(null),
      s = ji(o),
      c = T.useRef(null),
      _T$useState3 = T.useState({
    x: null,
    y: null,
    strategy: r,
    placement: n,
    middlewareData: {}
  }),
      _T$useState4 = _slicedToArray(_T$useState3, 2),
      u = _T$useState4[0],
      d = _T$useState4[1],
      _T$useState5 = T.useState(t),
      _T$useState6 = _slicedToArray(_T$useState5, 2),
      f = _T$useState6[0],
      p = _T$useState6[1];

  bt(f == null ? void 0 : f.map(function (y) {
    var $ = y.options;
    return $;
  }), t == null ? void 0 : t.map(function (y) {
    var $ = y.options;
    return $;
  })) || p(t);
  var g = T.useCallback(function () {
    !i.current || !a.current || Bi(i.current, a.current, {
      middleware: f,
      placement: n,
      strategy: r
    }).then(function (y) {
      v.current && pr.flushSync(function () {
        d(y);
      });
    });
  }, [f, n, r]);
  vt(function () {
    v.current && g();
  }, [g]);
  var v = T.useRef(!1);
  vt(function () {
    return v.current = !0, function () {
      v.current = !1;
    };
  }, []);
  var b = T.useCallback(function () {
    if (typeof c.current == "function" && (c.current(), c.current = null), i.current && a.current) if (s.current) {
      var y = s.current(i.current, a.current, g);
      c.current = y;
    } else g();
  }, [g, s]),
      m = T.useCallback(function (y) {
    i.current = y, b();
  }, [b]),
      x = T.useCallback(function (y) {
    a.current = y, b();
  }, [b]),
      w = T.useMemo(function () {
    return {
      reference: i,
      floating: a
    };
  }, []);
  return T.useMemo(function () {
    return _objectSpread(_objectSpread({}, u), {}, {
      update: g,
      refs: w,
      reference: m,
      floating: x
    });
  }, [u, g, w, m, x]);
}

var Wi = function Wi(e) {
  var t = e.element,
      n = e.padding;

  function r(o) {
    return Object.prototype.hasOwnProperty.call(o, "current");
  }

  return {
    name: "arrow",
    options: e,
    fn: function fn(o) {
      return r(t) ? t.current != null ? nn({
        element: t.current,
        padding: n
      }).fn(o) : {} : t ? nn({
        element: t,
        padding: n
      }).fn(o) : {};
    }
  };
},
    Vi = l.forwardRef(function (e, t) {
  var n = e.children,
      _e$width = e.width,
      r = _e$width === void 0 ? 10 : _e$width,
      _e$height = e.height,
      o = _e$height === void 0 ? 5 : _e$height,
      i = _objectWithoutProperties(e, _excluded22);

  return l.createElement(oe.svg, U({}, i, {
    ref: t,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : l.createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
}),
    zi = Vi;

function Gi(e) {
  var _l$useState27 = l.useState(void 0),
      _l$useState28 = _slicedToArray(_l$useState27, 2),
      t = _l$useState28[0],
      n = _l$useState28[1];

  return de(function () {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      var r = new ResizeObserver(function (o) {
        if (!Array.isArray(o) || !o.length) return;
        var i = o[0];
        var a, s;

        if ("borderBoxSize" in i) {
          var c = i.borderBoxSize,
              u = Array.isArray(c) ? c[0] : c;
          a = u.inlineSize, s = u.blockSize;
        } else a = e.offsetWidth, s = e.offsetHeight;

        n({
          width: a,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), function () {
        return r.unobserve(e);
      };
    } else n(void 0);
  }, [e]), t;
}

var Qn = "Popper",
    _Mn = Mn(Qn),
    _Mn2 = _slicedToArray(_Mn, 2),
    Ht = _Mn2[0],
    Zn = _Mn2[1],
    _Ht = Ht(Qn),
    _Ht2 = _slicedToArray(_Ht, 2),
    qi = _Ht2[0],
    Jn = _Ht2[1],
    Ki = function Ki(e) {
  var t = e.__scopePopper,
      n = e.children,
      _l$useState29 = l.useState(null),
      _l$useState30 = _slicedToArray(_l$useState29, 2),
      r = _l$useState30[0],
      o = _l$useState30[1];

  return l.createElement(qi, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
},
    Yi = "PopperAnchor",
    Xi = l.forwardRef(function (e, t) {
  var n = e.__scopePopper,
      r = e.virtualRef,
      o = _objectWithoutProperties(e, _excluded23),
      i = Jn(Yi, n),
      a = l.useRef(null),
      s = fe(t, a);

  return l.useEffect(function () {
    i.onAnchorChange((r == null ? void 0 : r.current) || a.current);
  }), r ? null : l.createElement(oe.div, U({}, o, {
    ref: s
  }));
}),
    je = "PopperContent",
    _Ht3 = Ht(je),
    _Ht4 = _slicedToArray(_Ht3, 2),
    Qi = _Ht4[0],
    Zi = _Ht4[1],
    _Ht5 = Ht(je, {
  hasParent: !1,
  positionUpdateFns: new Set()
}),
    _Ht6 = _slicedToArray(_Ht5, 2),
    Ji = _Ht6[0],
    ea = _Ht6[1],
    ta = l.forwardRef(function (e, t) {
  var n, r, o, i, a, s, c, u;

  var d = e.__scopePopper,
      _e$side = e.side,
      f = _e$side === void 0 ? "bottom" : _e$side,
      _e$sideOffset = e.sideOffset,
      p = _e$sideOffset === void 0 ? 0 : _e$sideOffset,
      _e$align = e.align,
      g = _e$align === void 0 ? "center" : _e$align,
      _e$alignOffset = e.alignOffset,
      v = _e$alignOffset === void 0 ? 0 : _e$alignOffset,
      _e$arrowPadding = e.arrowPadding,
      b = _e$arrowPadding === void 0 ? 0 : _e$arrowPadding,
      _e$collisionBoundary = e.collisionBoundary,
      m = _e$collisionBoundary === void 0 ? [] : _e$collisionBoundary,
      _e$collisionPadding = e.collisionPadding,
      x = _e$collisionPadding === void 0 ? 0 : _e$collisionPadding,
      _e$sticky = e.sticky,
      w = _e$sticky === void 0 ? "partial" : _e$sticky,
      _e$hideWhenDetached = e.hideWhenDetached,
      y = _e$hideWhenDetached === void 0 ? !1 : _e$hideWhenDetached,
      _e$avoidCollisions = e.avoidCollisions,
      $ = _e$avoidCollisions === void 0 ? !0 : _e$avoidCollisions,
      C = _objectWithoutProperties(e, _excluded24),
      E = Jn(je, d),
      _l$useState31 = l.useState(null),
      _l$useState32 = _slicedToArray(_l$useState31, 2),
      R = _l$useState32[0],
      O = _l$useState32[1],
      P = fe(t, function (tt) {
    return O(tt);
  }),
      _l$useState33 = l.useState(null),
      _l$useState34 = _slicedToArray(_l$useState33, 2),
      L = _l$useState34[0],
      D = _l$useState34[1],
      k = Gi(L),
      I = (n = k == null ? void 0 : k.width) !== null && n !== void 0 ? n : 0,
      j = (r = k == null ? void 0 : k.height) !== null && r !== void 0 ? r : 0,
      Y = f + (g !== "center" ? "-" + g : ""),
      Oe = typeof x == "number" ? x : _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, x),
      Re = Array.isArray(m) ? m : [m],
      Je = Re.length > 0,
      Se = {
    padding: Oe,
    boundary: Re.filter(aa),
    altBoundary: Je
  },
      _Ui = Ui({
    strategy: "fixed",
    placement: Y,
    whileElementsMounted: Hi,
    middleware: [Ei({
      mainAxis: p + j,
      alignmentAxis: v
    }), $ ? Pi(_objectSpread({
      mainAxis: !0,
      crossAxis: !1,
      limiter: w === "partial" ? Ci() : void 0
    }, Se)) : void 0, L ? Wi({
      element: L,
      padding: b
    }) : void 0, $ ? yi(_objectSpread({}, Se)) : void 0, la({
      arrowWidth: I,
      arrowHeight: j
    }), y ? wi({
      strategy: "referenceHidden"
    }) : void 0].filter(ia)
  }),
      Wt = _Ui.reference,
      rr = _Ui.floating,
      or = _Ui.strategy,
      Vt = _Ui.x,
      zt = _Ui.y,
      ir = _Ui.placement,
      ce = _Ui.middlewareData,
      et = _Ui.update;

  de(function () {
    Wt(E.anchor);
  }, [Wt, E.anchor]);

  var Ae = Vt !== null && zt !== null,
      _er = er(ir),
      _er2 = _slicedToArray(_er, 2),
      Gt = _er2[0],
      ar = _er2[1],
      lr = (o = ce.arrow) === null || o === void 0 ? void 0 : o.x,
      sr = (i = ce.arrow) === null || i === void 0 ? void 0 : i.y,
      cr = ((a = ce.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0,
      _l$useState35 = l.useState(),
      _l$useState36 = _slicedToArray(_l$useState35, 2),
      ur = _l$useState36[0],
      dr = _l$useState36[1];

  de(function () {
    R && dr(window.getComputedStyle(R).zIndex);
  }, [R]);

  var _ea = ea(je, d),
      fr = _ea.hasParent,
      ue = _ea.positionUpdateFns,
      me = !fr;

  l.useLayoutEffect(function () {
    if (!me) return ue.add(et), function () {
      ue.delete(et);
    };
  }, [me, ue, et]), l.useLayoutEffect(function () {
    me && Ae && Array.from(ue).reverse().forEach(function (tt) {
      return requestAnimationFrame(tt);
    });
  }, [me, Ae, ue]);

  var qt = _objectSpread(_objectSpread({
    "data-side": Gt,
    "data-align": ar
  }, C), {}, {
    ref: P,
    style: _objectSpread(_objectSpread({}, C.style), {}, {
      animation: Ae ? void 0 : "none",
      opacity: (s = ce.hide) !== null && s !== void 0 && s.referenceHidden ? 0 : void 0
    })
  });

  return l.createElement("div", {
    ref: rr,
    "data-radix-popper-content-wrapper": "",
    style: _defineProperty({
      position: or,
      left: 0,
      top: 0,
      transform: Ae ? "translate3d(".concat(Math.round(Vt), "px, ").concat(Math.round(zt), "px, 0)") : "translate3d(0, -200%, 0)",
      minWidth: "max-content",
      zIndex: ur
    }, "--radix-popper-transform-origin", [(c = ce.transformOrigin) === null || c === void 0 ? void 0 : c.x, (u = ce.transformOrigin) === null || u === void 0 ? void 0 : u.y].join(" "))
  }, l.createElement(Qi, {
    scope: d,
    placedSide: Gt,
    onArrowChange: D,
    arrowX: lr,
    arrowY: sr,
    shouldHideArrow: cr
  }, me ? l.createElement(Ji, {
    scope: d,
    hasParent: !0,
    positionUpdateFns: ue
  }, l.createElement(oe.div, qt)) : l.createElement(oe.div, qt)));
}),
    na = "PopperArrow",
    ra = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
},
    oa = l.forwardRef(function (t, n) {
  var _style2;

  var r = t.__scopePopper,
      o = _objectWithoutProperties(t, _excluded25),
      i = Zi(na, r),
      a = ra[i.placedSide];

  return l.createElement("span", {
    ref: i.onArrowChange,
    style: (_style2 = {
      position: "absolute",
      left: i.arrowX,
      top: i.arrowY
    }, _defineProperty(_style2, a, 0), _defineProperty(_style2, "transformOrigin", {
      top: "",
      right: "0 0",
      bottom: "center 0",
      left: "100% 0"
    }[i.placedSide]), _defineProperty(_style2, "transform", {
      top: "translateY(100%)",
      right: "translateY(50%) rotate(90deg) translateX(-50%)",
      bottom: "rotate(180deg)",
      left: "translateY(50%) rotate(-90deg) translateX(50%)"
    }[i.placedSide]), _defineProperty(_style2, "visibility", i.shouldHideArrow ? "hidden" : void 0), _style2)
  }, l.createElement(zi, U({}, o, {
    ref: n,
    style: _objectSpread(_objectSpread({}, o.style), {}, {
      display: "block"
    })
  })));
});

function ia(e) {
  return e !== void 0;
}

function aa(e) {
  return e !== null;
}

var la = function la(e) {
  return {
    name: "transformOrigin",
    options: e,
    fn: function fn(t) {
      var n, r, o, i, a;

      var s = t.placement,
          c = t.rects,
          u = t.middlewareData,
          f = ((n = u.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0,
          p = f ? 0 : e.arrowWidth,
          g = f ? 0 : e.arrowHeight,
          _er3 = er(s),
          _er4 = _slicedToArray(_er3, 2),
          v = _er4[0],
          b = _er4[1],
          m = {
        start: "0%",
        center: "50%",
        end: "100%"
      }[b],
          x = ((r = (o = u.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + p / 2,
          w = ((i = (a = u.arrow) === null || a === void 0 ? void 0 : a.y) !== null && i !== void 0 ? i : 0) + g / 2;

      var y = "",
          $ = "";
      return v === "bottom" ? (y = f ? m : "".concat(x, "px"), $ = "".concat(-g, "px")) : v === "top" ? (y = f ? m : "".concat(x, "px"), $ = "".concat(c.floating.height + g, "px")) : v === "right" ? (y = "".concat(-g, "px"), $ = f ? m : "".concat(w, "px")) : v === "left" && (y = "".concat(c.floating.width + g, "px"), $ = f ? m : "".concat(w, "px")), {
        data: {
          x: y,
          y: $
        }
      };
    }
  };
};

function er(e) {
  var _e$split = e.split("-"),
      _e$split2 = _slicedToArray(_e$split, 2),
      t = _e$split2[0],
      _e$split2$ = _e$split2[1],
      n = _e$split2$ === void 0 ? "center" : _e$split2$;

  return [t, n];
}

var sa = Ki,
    ca = Xi,
    ua = ta,
    da = oa,
    fa = l.forwardRef(function (e, t) {
  var n;

  var _e$container = e.container,
      r = _e$container === void 0 ? globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body : _e$container,
      o = _objectWithoutProperties(e, _excluded26);

  return r ? gr.default.createPortal(l.createElement(oe.div, U({}, o, {
    ref: t
  })), r) : null;
});

function pa(e, t) {
  return l.useReducer(function (n, r) {
    var o = t[n][r];
    return o != null ? o : n;
  }, e);
}

var Bt = function Bt(e) {
  var t = e.present,
      n = e.children,
      r = ga(t),
      o = typeof n == "function" ? n({
    present: r.isPresent
  }) : l.Children.only(n),
      i = fe(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? l.cloneElement(o, {
    ref: i
  }) : null;
};

Bt.displayName = "Presence";

function ga(e) {
  var _l$useState37 = l.useState(),
      _l$useState38 = _slicedToArray(_l$useState37, 2),
      t = _l$useState38[0],
      n = _l$useState38[1],
      r = l.useRef({}),
      o = l.useRef(e),
      i = l.useRef("none"),
      a = e ? "mounted" : "unmounted",
      _pa = pa(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }),
      _pa2 = _slicedToArray(_pa, 2),
      s = _pa2[0],
      c = _pa2[1];

  return l.useEffect(function () {
    var u = Le(r.current);
    i.current = s === "mounted" ? u : "none";
  }, [s]), de(function () {
    var u = r.current,
        d = o.current;

    if (d !== e) {
      var p = i.current,
          g = Le(u);
      e ? c("MOUNT") : g === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && p !== g ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), de(function () {
    if (t) {
      var u = function u(f) {
        var g = Le(r.current).includes(f.animationName);
        f.target === t && g && Ue.flushSync(function () {
          return c("ANIMATION_END");
        });
      },
          d = function d(f) {
        f.target === t && (i.current = Le(r.current));
      };

      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), function () {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: l.useCallback(function (u) {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}

function Le(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}

function ma(_ref34) {
  var e = _ref34.prop,
      t = _ref34.defaultProp,
      _ref34$onChange = _ref34.onChange,
      n = _ref34$onChange === void 0 ? function () {} : _ref34$onChange;

  var _va = va({
    defaultProp: t,
    onChange: n
  }),
      _va2 = _slicedToArray(_va, 2),
      r = _va2[0],
      o = _va2[1],
      i = e !== void 0,
      a = i ? e : r,
      s = Pe(n),
      c = l.useCallback(function (u) {
    if (i) {
      var f = typeof u == "function" ? u(e) : u;
      f !== e && s(f);
    } else o(u);
  }, [i, e, o, s]);

  return [a, c];
}

function va(_ref35) {
  var e = _ref35.defaultProp,
      t = _ref35.onChange;

  var n = l.useState(e),
      _n2 = _slicedToArray(n, 1),
      r = _n2[0],
      o = l.useRef(r),
      i = Pe(t);

  return l.useEffect(function () {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}

var ba = l.forwardRef(function (e, t) {
  return l.createElement(oe.span, U({}, e, {
    ref: t,
    style: _objectSpread({
      position: "absolute",
      border: 0,
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      wordWrap: "normal"
    }, e.style)
  }));
}),
    ha = ba,
    _Mn3 = Mn("Tooltip", [Zn]),
    _Mn4 = _slicedToArray(_Mn3, 2),
    Qe = _Mn4[0],
    Za = _Mn4[1],
    Ze = Zn(),
    xa = "TooltipProvider",
    ya = 700,
    ht = "tooltip.open",
    _Qe = Qe(xa),
    _Qe2 = _slicedToArray(_Qe, 2),
    wa = _Qe2[0],
    jt = _Qe2[1],
    $a = function $a(e) {
  var t = e.__scopeTooltip,
      _e$delayDuration = e.delayDuration,
      n = _e$delayDuration === void 0 ? ya : _e$delayDuration,
      _e$skipDelayDuration = e.skipDelayDuration,
      r = _e$skipDelayDuration === void 0 ? 300 : _e$skipDelayDuration,
      _e$disableHoverableCo = e.disableHoverableContent,
      o = _e$disableHoverableCo === void 0 ? !1 : _e$disableHoverableCo,
      i = e.children,
      _l$useState39 = l.useState(!0),
      _l$useState40 = _slicedToArray(_l$useState39, 2),
      a = _l$useState40[0],
      s = _l$useState40[1],
      c = l.useRef(!1),
      u = l.useRef(0);

  return l.useEffect(function () {
    var d = u.current;
    return function () {
      return window.clearTimeout(d);
    };
  }, []), l.createElement(wa, {
    scope: t,
    isOpenDelayed: a,
    delayDuration: n,
    onOpen: l.useCallback(function () {
      window.clearTimeout(u.current), s(!1);
    }, []),
    onClose: l.useCallback(function () {
      window.clearTimeout(u.current), u.current = window.setTimeout(function () {
        return s(!0);
      }, r);
    }, [r]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: l.useCallback(function (d) {
      c.current = d;
    }, []),
    disableHoverableContent: o
  }, i);
},
    Ut = "Tooltip",
    _Qe3 = Qe(Ut),
    _Qe4 = _slicedToArray(_Qe3, 2),
    Ea = _Qe4[0],
    Te = _Qe4[1],
    Pa = function Pa(e) {
  var t = e.__scopeTooltip,
      n = e.children,
      r = e.open,
      _e$defaultOpen2 = e.defaultOpen,
      o = _e$defaultOpen2 === void 0 ? !1 : _e$defaultOpen2,
      i = e.onOpenChange,
      a = e.disableHoverableContent,
      s = e.delayDuration,
      c = jt(Ut, e.__scopeTooltip),
      u = Ze(t),
      _l$useState41 = l.useState(null),
      _l$useState42 = _slicedToArray(_l$useState41, 2),
      d = _l$useState42[0],
      f = _l$useState42[1],
      p = ui(),
      g = l.useRef(0),
      v = a != null ? a : c.disableHoverableContent,
      b = s != null ? s : c.delayDuration,
      m = l.useRef(!1),
      _ma = ma({
    prop: r,
    defaultProp: o,
    onChange: function onChange(R) {
      R ? (c.onOpen(), document.dispatchEvent(new CustomEvent(ht))) : c.onClose(), i == null || i(R);
    }
  }),
      _ma2 = _slicedToArray(_ma, 2),
      _ma2$ = _ma2[0],
      x = _ma2$ === void 0 ? !1 : _ma2$,
      w = _ma2[1],
      y = l.useMemo(function () {
    return x ? m.current ? "delayed-open" : "instant-open" : "closed";
  }, [x]),
      $ = l.useCallback(function () {
    window.clearTimeout(g.current), m.current = !1, w(!0);
  }, [w]),
      C = l.useCallback(function () {
    window.clearTimeout(g.current), w(!1);
  }, [w]),
      E = l.useCallback(function () {
    window.clearTimeout(g.current), g.current = window.setTimeout(function () {
      m.current = !0, w(!0);
    }, b);
  }, [b, w]);

  return l.useEffect(function () {
    return function () {
      return window.clearTimeout(g.current);
    };
  }, []), l.createElement(sa, u, l.createElement(Ea, {
    scope: t,
    contentId: p,
    open: x,
    stateAttribute: y,
    trigger: d,
    onTriggerChange: f,
    onTriggerEnter: l.useCallback(function () {
      c.isOpenDelayed ? E() : $();
    }, [c.isOpenDelayed, E, $]),
    onTriggerLeave: l.useCallback(function () {
      v ? C() : window.clearTimeout(g.current);
    }, [C, v]),
    onOpen: $,
    onClose: C,
    disableHoverableContent: v
  }, n));
},
    dn = "TooltipTrigger",
    Ca = l.forwardRef(function (e, t) {
  var n = e.__scopeTooltip,
      r = _objectWithoutProperties(e, _excluded27),
      o = Te(dn, n),
      i = jt(dn, n),
      a = Ze(n),
      s = l.useRef(null),
      c = fe(t, s, o.onTriggerChange),
      u = l.useRef(!1),
      d = l.useRef(!1),
      f = l.useCallback(function () {
    return u.current = !1;
  }, []);

  return l.useEffect(function () {
    return function () {
      return document.removeEventListener("pointerup", f);
    };
  }, [f]), l.createElement(ca, U({
    asChild: !0
  }, a), l.createElement(oe.button, U({
    "aria-describedby": o.open ? o.contentId : void 0,
    "data-state": o.stateAttribute
  }, r, {
    ref: c,
    onPointerMove: Q(e.onPointerMove, function (p) {
      p.pointerType !== "touch" && !d.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
    }),
    onPointerLeave: Q(e.onPointerLeave, function () {
      o.onTriggerLeave(), d.current = !1;
    }),
    onPointerDown: Q(e.onPointerDown, function () {
      u.current = !0, document.addEventListener("pointerup", f, {
        once: !0
      });
    }),
    onFocus: Q(e.onFocus, function () {
      u.current || o.onOpen();
    }),
    onBlur: Q(e.onBlur, o.onClose),
    onClick: Q(e.onClick, function (p) {
      p.detail === 0 && o.onClose();
    })
  })));
}),
    tr = "TooltipPortal",
    _Qe5 = Qe(tr, {
  forceMount: void 0
}),
    _Qe6 = _slicedToArray(_Qe5, 2),
    Ta = _Qe6[0],
    Oa = _Qe6[1],
    Ra = function Ra(e) {
  var t = e.__scopeTooltip,
      n = e.forceMount,
      r = e.children,
      o = e.container,
      i = Te(tr, t);
  return l.createElement(Ta, {
    scope: t,
    forceMount: n
  }, l.createElement(Bt, {
    present: n || i.open
  }, l.createElement(fa, {
    asChild: !0,
    container: o
  }, r)));
},
    ye = "TooltipContent",
    Sa = l.forwardRef(function (e, t) {
  var n = Oa(ye, e.__scopeTooltip),
      _e$forceMount = e.forceMount,
      r = _e$forceMount === void 0 ? n.forceMount : _e$forceMount,
      _e$side2 = e.side,
      o = _e$side2 === void 0 ? "top" : _e$side2,
      i = _objectWithoutProperties(e, _excluded28),
      a = Te(ye, e.__scopeTooltip);

  return l.createElement(Bt, {
    present: r || a.open
  }, a.disableHoverableContent ? l.createElement(nr, U({
    side: o
  }, i, {
    ref: t
  })) : l.createElement(Aa, U({
    side: o
  }, i, {
    ref: t
  })));
}),
    Aa = l.forwardRef(function (e, t) {
  var n = Te(ye, e.__scopeTooltip),
      r = jt(ye, e.__scopeTooltip),
      o = l.useRef(null),
      i = fe(t, o),
      _l$useState43 = l.useState(null),
      _l$useState44 = _slicedToArray(_l$useState43, 2),
      a = _l$useState44[0],
      s = _l$useState44[1],
      c = n.trigger,
      u = n.onClose,
      d = o.current,
      f = r.onPointerInTransitChange,
      p = l.useCallback(function () {
    s(null), f(!1);
  }, [f]),
      g = l.useCallback(function (v, b) {
    var m = v.currentTarget,
        x = {
      x: v.clientX,
      y: v.clientY
    },
        w = Ia(x, m.getBoundingClientRect()),
        y = w === "right" || w === "bottom" ? -5 : 5,
        C = w === "right" || w === "left" ? {
      x: v.clientX + y,
      y: v.clientY
    } : {
      x: v.clientX,
      y: v.clientY + y
    },
        E = Fa(b.getBoundingClientRect()),
        R = Ma([C].concat(_toConsumableArray(E)));
    s(R), f(!0);
  }, [f]);

  return l.useEffect(function () {
    return function () {
      return p();
    };
  }, [p]), l.useEffect(function () {
    if (c && d) {
      var v = function v(m) {
        return g(m, d);
      },
          b = function b(m) {
        return g(m, c);
      };

      return c.addEventListener("pointerleave", v), d.addEventListener("pointerleave", b), function () {
        c.removeEventListener("pointerleave", v), d.removeEventListener("pointerleave", b);
      };
    }
  }, [c, d, g, p]), l.useEffect(function () {
    if (a) {
      var v = function v(b) {
        var m = b.target,
            x = {
          x: b.clientX,
          y: b.clientY
        },
            w = (c == null ? void 0 : c.contains(m)) || (d == null ? void 0 : d.contains(m)),
            y = !_a(x, a);
        w ? p() : y && (p(), u());
      };

      return document.addEventListener("pointermove", v), function () {
        return document.removeEventListener("pointermove", v);
      };
    }
  }, [c, d, a, u, p]), l.createElement(nr, U({}, e, {
    ref: i
  }));
}),
    _Qe7 = Qe(Ut, {
  isInside: !1
}),
    _Qe8 = _slicedToArray(_Qe7, 2),
    Da = _Qe8[0],
    Na = _Qe8[1],
    nr = l.forwardRef(function (e, t) {
  var n = e.__scopeTooltip,
      r = e.children,
      o = e["aria-label"],
      i = e.onEscapeKeyDown,
      a = e.onPointerDownOutside,
      s = _objectWithoutProperties(e, _excluded29),
      c = Te(ye, n),
      u = Ze(n),
      d = c.onClose;

  return l.useEffect(function () {
    return document.addEventListener(ht, d), function () {
      return document.removeEventListener(ht, d);
    };
  }, [d]), l.useEffect(function () {
    if (c.trigger) {
      var f = function f(p) {
        var g = p.target;
        g != null && g.contains(c.trigger) && d();
      };

      return window.addEventListener("scroll", f, {
        capture: !0
      }), function () {
        return window.removeEventListener("scroll", f, {
          capture: !0
        });
      };
    }
  }, [c.trigger, d]), l.createElement(ii, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: i,
    onPointerDownOutside: a,
    onFocusOutside: function onFocusOutside(f) {
      return f.preventDefault();
    },
    onDismiss: d
  }, l.createElement(ua, U({
    "data-state": c.stateAttribute
  }, u, s, {
    ref: t,
    style: _objectSpread(_objectSpread({}, s.style), {}, _defineProperty({}, "--radix-tooltip-content-transform-origin", "var(--radix-popper-transform-origin)"))
  }), l.createElement(Bn, null, r), l.createElement(Da, {
    scope: n,
    isInside: !0
  }, l.createElement(ha, {
    id: c.contentId,
    role: "tooltip"
  }, o || r))));
}),
    La = "TooltipArrow",
    ka = l.forwardRef(function (e, t) {
  var n = e.__scopeTooltip,
      r = _objectWithoutProperties(e, _excluded30),
      o = Ze(n);

  return Na(La, n).isInside ? null : l.createElement(da, U({}, o, r, {
    ref: t
  }));
});

function Ia(e, t) {
  var n = Math.abs(t.top - e.y),
      r = Math.abs(t.bottom - e.y),
      o = Math.abs(t.right - e.x),
      i = Math.abs(t.left - e.x);

  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";

    case o:
      return "right";

    case n:
      return "top";

    case r:
      return "bottom";

    default:
      return null;
  }
}

function Fa(e) {
  var t = e.top,
      n = e.right,
      r = e.bottom,
      o = e.left;
  return [{
    x: o,
    y: t
  }, {
    x: n,
    y: t
  }, {
    x: n,
    y: r
  }, {
    x: o,
    y: r
  }];
}

function _a(e, t) {
  var n = e.x,
      r = e.y;
  var o = !1;

  for (var i = 0, a = t.length - 1; i < t.length; a = i++) {
    var s = t[i].x,
        c = t[i].y,
        u = t[a].x,
        d = t[a].y;
    c > r != d > r && n < (u - s) * (r - c) / (d - c) + s && (o = !o);
  }

  return o;
}

function Ma(e) {
  var t = e.slice();
  return t.sort(function (n, r) {
    return n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0;
  }), Ha(t);
}

function Ha(e) {
  if (e.length <= 1) return e.slice();
  var t = [];

  for (var r = 0; r < e.length; r++) {
    var o = e[r];

    for (; t.length >= 2;) {
      var i = t[t.length - 1],
          a = t[t.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) t.pop();else break;
    }

    t.push(o);
  }

  t.pop();
  var n = [];

  for (var _r5 = e.length - 1; _r5 >= 0; _r5--) {
    var _o2 = e[_r5];

    for (; n.length >= 2;) {
      var _i5 = n[n.length - 1],
          _a4 = n[n.length - 2];
      if ((_i5.x - _a4.x) * (_o2.y - _a4.y) >= (_i5.y - _a4.y) * (_o2.x - _a4.x)) n.pop();else break;
    }

    n.push(_o2);
  }

  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}

var Ba = $a,
    ja = Pa,
    Ua = Ca,
    Wa = Ra,
    Va = Sa,
    za = ka;

function Ga(_ref36) {
  var e = _ref36.value,
      t = _ref36.onChange,
      n = _ref36.groupLabel,
      r = _ref36.options,
      o = _ref36.className;
  return T.createElement(be, {
    value: e,
    onChange: t
  }, T.createElement(be.Label, {
    className: "gui-sr-only"
  }, n), T.createElement("div", {
    className: _("gui-grid gui-gap-3 gui-grid-col-1", "md:gui-gap-6 md:gui-grid-cols-filterList", o)
  }, r == null ? void 0 : r.map(function (i) {
    return T.createElement(be.Option, {
      key: i.value,
      value: i.value,
      className: function className(_ref37) {
        var a = _ref37.active,
            s = _ref37.checked;
        return _("gui-relative gui-flex gui-cursor-pointer gui-rounded-2xl gui-px-5 gui-py-3 md:gui-py-4 gui-shadow-md gui-focus:outline-none md:gui-min-h-[150px] gui-shadow-filterOption", a ? "gui-ring-offset-2 gui-ring-offset-filterOption-bgActive gui-ring-opacity-60 " : "", s ? "gui-bg-filterOption-bgActive gui-text-filterOption-textPrimary" : "gui-bg-filterOption-bgDefault gui-text-filterOption-textPrimary gui-transition hover:gui-bg-filterOption-bgHover");
      }
    }, function (_ref38) {
      var a = _ref38.active,
          s = _ref38.checked;
      return T.createElement(T.Fragment, null, i.tooltipInfo ? T.createElement("div", {
        className: "gui-absolute gui-top-3 gui-right-3"
      }, T.createElement(Ba, null, T.createElement(ja, {
        delayDuration: 0
      }, T.createElement(Ua, null, T.createElement(qa, {
        className: "gui-text-filterOption-tooltipIcon"
      })), T.createElement(Wa, null, T.createElement(Va, {
        className: "gui-max-w-[220px] gui-text-sm gui-text-filterOption-tooltipText gui-bg-filterOption-tooltipBg gui-rounded-md gui-px-4 gui-py-2 gui-shadow-tooltipContent"
      }, i.tooltipInfo, T.createElement(za, {
        className: "gui-fill-filterOption-tooltipBg"
      })))))) : null, T.createElement("div", {
        className: "gui-flex gui-flex-row md:gui-flex-col gui-text-sm gui-w-full md:gui-justify-center gui-items-center"
      }, i == null ? void 0 : i.icon, T.createElement(be.Label, {
        as: "p",
        className: _("gui-font-bold gui-text-md md:gui-text-xl gui-ml-3 md:gui-ml-0 md:gui-mb-1 md:gui-mt-3", (i == null ? void 0 : i.icon) == null && "gui-ml-0", s ? "gui-text-filterOption-textPrimary-active" : "gui-text-filterOption-textPrimary")
      }, i.label), T.createElement(be.Description, {
        as: "span",
        className: _("gui-hidden md:gui-block gui-font-medium gui-text-sm", s ? "gui-text-filterOption-textSecondary-active" : "gui-text-filterOption-textSecondary")
      }, i.aditionalText)));
    });
  })));
}

function qa(_ref39) {
  var e = _ref39.className;
  return T.createElement("svg", {
    width: "20",
    height: "20",
    className: e
  }, T.createElement("path", {
    d: "M10 1.66667c-4.59497 0-8.33333 3.73836-8.33333 8.33333 0 4.595 3.73836 8.3333 8.33333 8.3333 4.595 0 8.3333-3.7383 8.3333-8.3333 0-4.59497-3.7383-8.33333-8.3333-8.33333Zm0 1.25c3.9194 0 7.0833 3.16391 7.0833 7.08333 0 3.9194-3.1639 7.0833-7.0833 7.0833-3.91942 0-7.08333-3.1639-7.08333-7.0833 0-3.91942 3.16391-7.08333 7.08333-7.08333Zm0 2.91666c-.22101 0-.43298.0878-.58926.24408-.15628.15628-.24407.36824-.24407.58926 0 .22101.08779.43297.24407.58925C9.56702 7.4122 9.77899 7.5 10 7.5c.221 0 .433-.0878.5893-.24408.1562-.15628.244-.36824.244-.58925 0-.22102-.0878-.43298-.244-.58926-.1563-.15628-.3683-.24408-.5893-.24408Zm-.00977 2.90772c-.16561.00258-.32343.0708-.43879.18967-.11536.11887-.17882.27866-.17644.44428v4.5833c-.00117.0829.01413.1651.04501.2419.03089.0769.07674.1468.13489.2058.05815.059.12745.1058.20386.1378s.15841.0484.24124.0484c.0828 0 .1648-.0164.2412-.0484.0765-.032.1457-.0788.2039-.1378.0582-.059.104-.1289.1349-.2058.0309-.0768.0462-.159.045-.2419V9.375c.0012-.08365-.0144-.1667-.0459-.24421-.0315-.07751-.0782-.14791-.1374-.20703-.0592-.05912-.1297-.10575-.2072-.13714-.0776-.03138-.1606-.04688-.24427-.04557Z",
    fill: "currentColor"
  }));
}

var Ka = function Ka(_ref40) {
  var _ref40$disabled = _ref40.disabled,
      e = _ref40$disabled === void 0 ? !1 : _ref40$disabled,
      t = _ref40.children;
  return T.createElement(z, {
    disabled: e,
    className: function className(_ref41) {
      var n = _ref41.selected;
      return _("gui-w-full gui-rounded-[40px] gui-p-2 gui-text-sm gui-font-medium gui-leading-5", n ? "gui-bg-tabgroup-tabBgActive gui-text-tabgroup-tabTextActive" : "gui-bg-tabgroup-tabBg gui-text-tabgroup-tabText transition hover:gui-text-tabgroup-tabTextActive");
    }
  }, t);
},
    Ya = function Ya(_ref42) {
  var e = _ref42.children;
  return T.createElement(z.Panel, {
    className: _("rounded-xl gui-p-3", "focus:gui-outline-none")
  }, e);
};

function Xa(_ref43) {
  var e = _ref43.options,
      t = _ref43.className;
  return T.createElement(z.Group, {
    as: "div",
    className: t
  }, T.createElement(z.List, {
    className: "gui-max-w-[288px] md:gui-max-w-[516px] gui-mx-auto gui-flex gui-space-x-1 gui-bg-tabgroup-listBg gui-p-2 gui-rounded-[160px] md:gui-h-[64px] gui-shadow-tabGroup gui-mb-2 md:gui-mb-16"
  }, e.map(function (n) {
    return T.createElement(Ka, {
      key: n.name,
      disabled: n.disabled
    }, n.name);
  })), T.createElement(z.Panels, {
    className: "gui-mt-2"
  }, e.map(function (n) {
    return T.createElement(Ya, {
      key: n.name
    }, n.component);
  })));
}

var Qa = function Qa(_ref44) {
  var e = _ref44.title,
      t = _ref44.description,
      n = _ref44.imgUrl,
      r = _ref44.date,
      o = _ref44.url,
      _ref44$linkText = _ref44.linkText,
      i = _ref44$linkText === void 0 ? "Read More" : _ref44$linkText,
      a = _ref44.className;
  return h.default.createElement("div", {
    className: _("gui-flex gui-flex-col gui-space-y-6 md:gui-space-y-0 md:gui-flex-row md:gui-space-x-6 gui-bg-newsCard-bg gui-items-center", a)
  }, h.default.createElement("div", {
    className: "md:gui-basis-2/4 md:gui-max-w-[50%]"
  }, h.default.createElement("span", {
    className: "gui-block gui-text-newsCard-date gui-mb-2"
  }, r), h.default.createElement("h3", {
    className: "gui-text-xl md:gui-text-3xl gui-line-clamp-3 gui-text-newsCard-title gui-mb-3 md:gui-mb-6 gui-font-bold"
  }, e), h.default.createElement("p", {
    className: "gui-leading-relaxed md:gui-line-clamp-3 gui-mb-4 gui-text-newsCard-description"
  }, t), h.default.createElement("a", {
    href: o,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "gui-flex gui-items-center gui-text-newsCard-link gui-text-sm gui-font-medium"
  }, i, h.default.createElement(In, {
    className: "gui-ml-1 gui-text-newsCard-icon"
  }))), h.default.createElement("img", {
    className: "gui-block md:gui-basis-2/4 md:gui-max-w-[50%] gui-object-cover gui-rounded-3xl gui-aspect-video",
    src: n,
    alt: ""
  }));
};

exports.FilterList = Ga;
exports.NewsCard = Qa;
exports.ProposalCard = qo;
exports.Select = Ko;
exports.TabGroup = Xa;